var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCleaning(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-7"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 377.36,
    y: 33.25,
    width: 162.82,
    height: 260.97,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386.72,
    y: 41.31,
    width: 144.09,
    height: 244.85,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 378.87,
    y: 113.05,
    width: 152.57,
    height: 5.94,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 382.48,
    y: 203.38,
    width: 152.57,
    height: 5.94,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.89,156c.11.11-7.74,8.4-17.54,18.5s-17.85,18.22-18,18.1,7.74-8.39,17.54-18.51S447.77,155.87,447.89,156Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.5,233.66c.12.11-7.73,8.4-17.54,18.5s-17.84,18.22-18,18.1,7.74-8.39,17.54-18.51S513.39,233.54,513.5,233.66Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452,133.56c.11.11-11.86,12-26.75,26.53s-27,26.24-27.15,26.12,11.86-12,26.74-26.54S451.87,133.44,452,133.56Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.75,65.4a6.28,6.28,0,0,1-.86,1.1c-.57.68-1.43,1.65-2.51,2.83-2.15,2.36-5.21,5.56-8.71,9s-6.78,6.36-9.2,8.44c-1.21,1-2.21,1.88-2.91,2.43a6.18,6.18,0,0,1-1.12.82,6.19,6.19,0,0,1,1-1l2.78-2.57c2.35-2.16,5.58-5.16,9.07-8.55s6.59-6.54,8.82-8.82l2.64-2.71A6,6,0,0,1,511.75,65.4Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 459.09,
    y: 38.69,
    width: 7.88,
    height: 251.38,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.6,275.94s-3.74,2.82-3.74,6.56v19.11h27.86v-20s-.39-4.9-3.66-5.71Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148,300.57a54.23,54.23,0,0,1-.41-5.87,4.72,4.72,0,0,1,3.27-4.33c1.47-.4,3,.13,4.51.38a12,12,0,0,0,7.21-1.07c1.88-.94,3.6-2.4,5.69-2.59a3.07,3.07,0,0,1,3.33,1.84,4.66,4.66,0,0,1,0,1.93c-.45,2.95.12,6.61.12,9.44-7.8.36-15.88.1-23.69.27",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "144.09 304.31 148.29 301.61 173.72 301.61 177.81 304.31 144.09 304.31",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.3,242.15V270.6h34.51v33.71H144.09v8.08h58.16V242.15a6.05,6.05,0,0,0-6.05-6.05H149.36A6.06,6.06,0,0,0,143.3,242.15Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.25,242.8c0,.14-13.19.25-29.47.25s-29.48-.11-29.48-.25,13.2-.25,29.48-.25S202.25,242.66,202.25,242.8Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.89,312.39c-.14,0-.25-17-.25-38.05s.11-38,.25-38,.25,17,.25,38S186,312.39,185.89,312.39Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.18,292.39l-.34-8.61a11.6,11.6,0,0,1,1.87-7,6.18,6.18,0,0,1,5.08-3.08h23.27v2.27H147.22s-4.11.43-4.66,6.06a55.77,55.77,0,0,0,0,10.39Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161.33,
    y: 446.63,
    width: 10.2,
    height: 18.4,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.42,
    y: 446.63,
    width: 10.2,
    height: 18.4,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.91,
    y: 312.39,
    width: 84.52,
    height: 134.23,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.42,
    y: 312.39,
    width: 82.33,
    height: 134.23,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.7,
    y: 446.63,
    width: 10.2,
    height: 18.4,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.38,
    y: 446.63,
    width: 10.2,
    height: 18.4,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.2,410.09s0-.17,0-.49,0-.8,0-1.41c0-1.24,0-3.06,0-5.41,0-4.69,0-11.48-.07-19.92l.12.11-70.65.06h0l.17-.17c0,9.52,0,18.71,0,27.23l-.16-.16,50.62.07,14.72,0,3.94,0h0l-3.91,0-14.68,0-50.73.08h-.16V382.69h.17l70.65.05h.12v.12c0,8.47,0,15.28-.06,20,0,2.34,0,4.15,0,5.38,0,.61,0,1.07,0,1.39S199.2,410.09,199.2,410.09Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166,396.47a3.53,3.53,0,0,1-.13-.5,2.18,2.18,0,0,0-.79-1.1,2,2,0,1,0-1.89,3.46,2,2,0,0,0,1.89-.26,2.12,2.12,0,0,0,.79-1.09,3.48,3.48,0,0,1,.13-.51,1.19,1.19,0,0,1,0,.54,2.07,2.07,0,0,1-.77,1.25,2.23,2.23,0,0,1-2.14.36,2.28,2.28,0,0,1,0-4.3,2.25,2.25,0,0,1,2.14.36,2.11,2.11,0,0,1,.77,1.26A1.15,1.15,0,0,1,166,396.47Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.2,441.92s0-.17,0-.48,0-.8,0-1.41c0-1.25,0-3.07,0-5.41,0-4.69,0-11.48-.07-19.92l.12.11-70.65.05h0l.17-.16c0,9.51,0,18.71,0,27.22l-.16-.16,50.62.08,14.72,0,3.94,0h0L194,442l-14.68.05-50.73.07h-.16V414.53h.17l70.65.05h.12v.12c0,8.47,0,15.28-.06,20,0,2.33,0,4.14,0,5.38,0,.6,0,1.07,0,1.39S199.2,441.92,199.2,441.92Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166,428.31a3.48,3.48,0,0,1-.13-.51,2.16,2.16,0,0,0-.79-1.09,2,2,0,1,0,0,3.2,2.18,2.18,0,0,0,.79-1.1,3.53,3.53,0,0,1,.13-.5,1.19,1.19,0,0,1,0,.54,2.12,2.12,0,0,1-.77,1.25,2.25,2.25,0,0,1-2.14.36,2.28,2.28,0,0,1,0-4.3,2.23,2.23,0,0,1,2.14.36,2.09,2.09,0,0,1,.77,1.25A1.19,1.19,0,0,1,166,428.31Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.2,377.48s0-.17,0-.49,0-.79,0-1.41c0-1.24,0-3.06,0-5.4,0-4.69,0-11.49-.07-19.92l.12.11-70.65.05h0l.17-.16c0,9.51,0,18.71,0,27.22l-.16-.16,50.62.08,14.72,0,3.94,0h0l-3.91,0-14.68.05-50.73.07h-.16V350.09h.17l70.65.05h.12v.12c0,8.46,0,15.28-.06,20,0,2.33,0,4.14,0,5.38,0,.6,0,1.06,0,1.39S199.2,377.48,199.2,377.48Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166,363.87a3.48,3.48,0,0,1-.13-.51,2.16,2.16,0,0,0-.79-1.09,2,2,0,0,0-1.89-.26,2,2,0,1,0,1.89,3.46,2.18,2.18,0,0,0,.79-1.1,3.53,3.53,0,0,1,.13-.5,1.15,1.15,0,0,1,0,.53,2.11,2.11,0,0,1-.77,1.26,2.25,2.25,0,0,1-2.14.36,2.28,2.28,0,0,1,0-4.3,2.23,2.23,0,0,1,2.14.36,2.07,2.07,0,0,1,.77,1.25A1.19,1.19,0,0,1,166,363.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.2,345.32s0-.17,0-.49,0-.8,0-1.41c0-1.24,0-3.06,0-5.41,0-4.69,0-11.48-.07-19.92l.12.12-70.65.05h0l.17-.17c0,9.52,0,18.71,0,27.23l-.16-.16,50.62.07,14.72,0,3.94,0h0l-3.91,0-14.68,0-50.73.08h-.16V317.92h.17l70.65.06h.12v.11c0,8.47,0,15.28-.06,20,0,2.34,0,4.15,0,5.38,0,.61,0,1.07,0,1.39S199.2,345.32,199.2,345.32Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166,331.7a3.53,3.53,0,0,1-.13-.5,2.18,2.18,0,0,0-.79-1.1,2,2,0,0,0-3.19,1.6,2,2,0,0,0,3.19,1.61,2.18,2.18,0,0,0,.79-1.1,3.48,3.48,0,0,1,.13-.51,1.19,1.19,0,0,1,0,.54,2.07,2.07,0,0,1-.77,1.25,2.23,2.23,0,0,1-2.14.36,2.27,2.27,0,0,1,0-4.29,2.23,2.23,0,0,1,2.14.35,2.11,2.11,0,0,1,.77,1.26A1.15,1.15,0,0,1,166,331.7Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.41,312.39c0,.14-12.82.25-28.63.25s-28.63-.11-28.63-.25,12.82-.25,28.63-.25S201.41,312.25,201.41,312.39Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "141.93 85.26 141.93 163.33 41.1 163.33 37.47 85.81 141.93 85.26",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.08,
    y: 74.11,
    width: 77.61,
    height: 100.83,
    transform: "translate(-36.64 212.4) rotate(-90)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.68,163.71H37.08V85.33h101.6Zm-100.83-.77H137.91V86.1H37.85Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.39,
    y: 93.69,
    width: 78.99,
    height: 59.42,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.37,93.69h-1.49l-4.3,0-16.2,0-57,.09.18-.18c0,17.83,0,38.06,0,59.42h0l-.2-.2,79,0-.16.16c0-18,.07-32.79.09-43.14,0-5.18,0-9.24,0-12,0-1.38,0-2.44,0-3.16s0-1.1,0-1.1,0,.36,0,1.06,0,1.77,0,3.14c0,2.76,0,6.81,0,12,0,10.38,0,25.25.09,43.25v.17h-.17l-79,0h-.2v-.2h0c0-21.36,0-41.59,0-59.42v-.18h.18l57.11.09,16.15.05,4.27,0h1.45Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.47,85.54a9.11,9.11,0,0,1,1.7,1c1,.69,2.42,1.67,3.94,2.79s2.86,2.18,3.8,3a10,10,0,0,1,1.48,1.35,9.88,9.88,0,0,1-1.65-1.13l-3.87-2.87L39,86.81A9.61,9.61,0,0,1,37.47,85.54Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.3,85.72A59.62,59.62,0,0,1,133,89.87a55.34,55.34,0,0,1-5.58,3.82,59.62,59.62,0,0,1,5.35-4.15A55.34,55.34,0,0,1,138.3,85.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 138.3,
    y1: 163.33,
    x2: 126.97,
    y2: 153.11,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127,153.11a72.69,72.69,0,0,1,5.8,5,73.2,73.2,0,0,1,5.53,5.26,72.69,72.69,0,0,1-5.8-5A73.2,73.2,0,0,1,127,153.11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.47,163.33a63.34,63.34,0,0,1,5.27-5,65.72,65.72,0,0,1,5.54-4.73,69.71,69.71,0,0,1-5.27,5A69.66,69.66,0,0,1,37.47,163.33Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.17,104.65c0,.11-7.82.21-17.45.21s-17.46-.1-17.46-.21,7.82-.21,17.46-.21S106.17,104.53,106.17,104.65Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114,124.3c0,.11-11.71.2-26.15.2s-26.15-.09-26.15-.2,11.71-.21,26.15-.21S114,124.18,114,124.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114,129.15c0,.11-11.71.21-26.15.21s-26.15-.1-26.15-.21,11.71-.21,26.15-.21S114,129,114,129.15Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.14,114.42a3.13,3.13,0,0,1,3.33-3.14,3.19,3.19,0,0,1,2.59,1.14l-1.08,1a1.81,1.81,0,0,0-1.43-.7,1.73,1.73,0,0,0,0,3.45,1.79,1.79,0,0,0,1.43-.71l1.08,1a3.18,3.18,0,0,1-2.59,1.13A3.13,3.13,0,0,1,59.14,114.42Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.67,116.12v1.32H65.82v-6h4.74v1.32h-3v1H70.2V115H67.52v1.1Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.27,115.84h-.94v1.6h-1.7v-6h2.76c1.65,0,2.68.86,2.68,2.24a2,2,0,0,1-1.18,1.9l1.3,1.9H75.36Zm0-3.09h-1v1.77h1c.71,0,1.06-.33,1.06-.88S75,112.75,74.28,112.75Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.21,112.76H77.36V111.4h5.41v1.36H80.92v4.68H79.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.41,111.4h1.71v6H83.41Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88,112.72v1.33h2.67v1.32H88v2.07H86.33v-6h4.74v1.32Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.88,111.4h1.7v6h-1.7Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.49,114.42a3.12,3.12,0,0,1,3.32-3.14,3.19,3.19,0,0,1,2.6,1.14l-1.09,1a1.78,1.78,0,0,0-1.42-.7,1.73,1.73,0,0,0,0,3.45,1.76,1.76,0,0,0,1.42-.71l1.09,1a3.19,3.19,0,0,1-2.6,1.13A3.12,3.12,0,0,1,94.49,114.42Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.12,116.27h-2.56l-.47,1.17h-1.75l2.67-6h1.68l2.68,6h-1.78Zm-.5-1.26-.78-1.93-.78,1.93Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.84,112.76H107V111.4h5.41v1.36h-1.84v4.68h-1.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.88,116.12v1.32H113v-6h4.74v1.32h-3v1h2.68V115h-2.68v1.1Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.74,141.22a6.09,6.09,0,1,1-6.09-6.09A6.08,6.08,0,0,1,94.74,141.22Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.65,147.32a6.11,6.11,0,1,1,6.11-6.1A6.11,6.11,0,0,1,88.65,147.32Zm0-12.17a6.07,6.07,0,1,0,6.07,6.07A6.07,6.07,0,0,0,88.65,135.15Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.28,141.22a67.6,67.6,0,0,1-7.33.2,67.72,67.72,0,0,1-7.34-.2A63.28,63.28,0,0,1,69,141,63.17,63.17,0,0,1,76.28,141.22Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.48,141.22c0,.11-3.67.2-8.2.2s-8.2-.09-8.2-.2a78.85,78.85,0,0,1,8.2-.21A78.85,78.85,0,0,1,116.48,141.22Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.49,140.07a1.71,1.71,0,0,1-.09-.5,5.29,5.29,0,0,1,.08-1.47,5.52,5.52,0,0,1,.93-2.14,1.3,1.3,0,0,1,.63-.42,1,1,0,0,1,.8.17,1.46,1.46,0,0,1,.51,1.59,4.77,4.77,0,0,1-.89,1.58,7.51,7.51,0,0,1-1.35,1.42,3.91,3.91,0,0,1-1.93.89A3.08,3.08,0,0,1,69,140.7a2.39,2.39,0,0,1-1-2.17,7.09,7.09,0,0,1,.65-2.37,2.75,2.75,0,0,1,.8-1,1.75,1.75,0,0,1,1.34-.34,1.34,1.34,0,0,1,1,1,2.68,2.68,0,0,1-.09,1.38,8.37,8.37,0,0,1-1.2,2.32,5.27,5.27,0,0,1-1.94,1.66,3.93,3.93,0,0,1-2.45.31,2.93,2.93,0,0,1-2-1.37,3.79,3.79,0,0,1-.51-2.2,5.69,5.69,0,0,1,.53-2c.28-.59.61-1.29,1.35-1.48a.9.9,0,0,1,.93.43,1.94,1.94,0,0,1,.25.9,6,6,0,0,1-.73,3,6.18,6.18,0,0,1-1.45,1.81,5.61,5.61,0,0,1-1.23.79,2.08,2.08,0,0,1-.48.18,9.29,9.29,0,0,0,1.6-1.09,6.41,6.41,0,0,0,1.36-1.8,5.88,5.88,0,0,0,.64-2.87,1.6,1.6,0,0,0-.22-.75.56.56,0,0,0-.61-.28,1.12,1.12,0,0,0-.64.48,3.39,3.39,0,0,0-.45.82,4.17,4.17,0,0,0,0,3.9,2.5,2.5,0,0,0,1.7,1.18,3.51,3.51,0,0,0,2.2-.29A6.4,6.4,0,0,0,71.32,137a2.31,2.31,0,0,0,.07-1.16.88.88,0,0,0-.68-.69,1.31,1.31,0,0,0-1,.26,2.31,2.31,0,0,0-.67.89,6.69,6.69,0,0,0-.63,2.21,2,2,0,0,0,.8,1.84,2.74,2.74,0,0,0,1.94.44,3.72,3.72,0,0,0,1.77-.8,7.48,7.48,0,0,0,1.3-1.34,4.66,4.66,0,0,0,.87-1.46,1.2,1.2,0,0,0-.38-1.31.77.77,0,0,0-1.1.2,5.17,5.17,0,0,0-1,2A7.76,7.76,0,0,0,72.49,140.07Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.56,139.1l-.16.08a5.31,5.31,0,0,1-.49.22,14.74,14.74,0,0,1-1.94.67,18.37,18.37,0,0,1-3.21.59,19.09,19.09,0,0,1-2.05.08,21.11,21.11,0,0,0-2.26-.06,1.53,1.53,0,0,0-1,.5.94.94,0,0,0-.13,1,6,6,0,0,0,.75,1.07q.43.52.9,1t1,1.05a3.21,3.21,0,0,0,1.11.86,1,1,0,0,0,1.15-.41,2.09,2.09,0,0,0,.35-1.39,33.06,33.06,0,0,1,1.53-13.93l.17-.52.21.51a11.06,11.06,0,0,1,.82,3.63,11.88,11.88,0,0,1-.83,5.07,11.43,11.43,0,0,1-1.18,2.21A3.58,3.58,0,0,1,107.4,143a1.17,1.17,0,0,1-1.26-.45,2.3,2.3,0,0,1-.33-1.21,12.67,12.67,0,0,1,.07-2.31,13,13,0,0,1,1.27-4.18l.13-.26.18.23a2.8,2.8,0,1,1-4.53,3.3,2.91,2.91,0,0,1,.24-3.43,1.47,1.47,0,0,1,.7-.48.74.74,0,0,1,.82.22,1.11,1.11,0,0,1,.2.77,2.24,2.24,0,0,1-.15.7,9,9,0,0,1-2.25,3.52,9.51,9.51,0,0,1-.85.71l-.32.2s.09-.09.28-.25.47-.4.81-.74a9.26,9.26,0,0,0,2.12-3.51,1.41,1.41,0,0,0,0-1.25c-.28-.35-.84-.11-1.14.28a2.61,2.61,0,0,0-.19,3.09,2.47,2.47,0,1,0,4-2.91l.31,0a12.47,12.47,0,0,0-1.22,4.06,13.79,13.79,0,0,0-.06,2.23,2.1,2.1,0,0,0,.26,1,.77.77,0,0,0,.84.29,2.27,2.27,0,0,0,.94-.55,6.51,6.51,0,0,0,.73-.9,11,11,0,0,0,1.14-2.14,11.5,11.5,0,0,0,.8-4.89,11.18,11.18,0,0,0-.79-3.5h.39A33.16,33.16,0,0,0,109,144.45a2.42,2.42,0,0,1-.43,1.62,1.46,1.46,0,0,1-.69.53,1.24,1.24,0,0,1-.87,0,3.51,3.51,0,0,1-1.24-1c-.34-.35-.67-.71-1-1.07s-.61-.71-.9-1.07a6.64,6.64,0,0,1-.78-1.15,1.25,1.25,0,0,1,.18-1.36,1.86,1.86,0,0,1,1.17-.59,6,6,0,0,1,1.2,0c.38,0,.75.06,1.11.07a18.91,18.91,0,0,0,2-.05,18,18,0,0,0,3.19-.52,18.65,18.65,0,0,0,2-.59A3.8,3.8,0,0,1,114.56,139.1Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.25,454.85c-1.47-1.27-4.75-5.27-2.22-9.92.93-1.71,2.9-2.55,4.68-3.3a19,19,0,0,0,5.14-2.66c2.79-2.37,3.56-6.31,5.41-9.47,2.12-3.63,6.08-6.35,10.27-6.16,4.79.22,8.79,4.13,10.6,8.6s1.88,9.42,1.91,14.24c0,2.66-.09,5.67-2.05,7.47s-4.52,1.68-7,1.6l-26.19-.8",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.36,382.81h-68.9l12.41,74a8.28,8.28,0,0,0,5.89,6.59l.24.06c.2.05.4.12.61.16a9.08,9.08,0,0,0,1.4.16v.07l.34-.05h30.71a8.47,8.47,0,0,0,1.68-.17,8.29,8.29,0,0,0,7-7.23l6-51,.27-2h0l2.37-20.19Zm-13,47.2h-7.07l.71-21.48h8.2Zm2.52-21.48h6.77L503.13,430h-6.08Zm-20.2,45.29-.43-18.66h10.18l-.62,18.66Zm-11-18.66h9.89l.43,18.66h-8.87Zm.76,18.66h-8.29l-2.93-18.66H467ZM467.28,430l-1.67-21.48H477l.49,21.48Zm10.85,0-.49-21.48h11.68L488.61,430Zm-.61-26.63-.46-19.89h13.09l-.66,19.89Zm-.68,0H465.21l-1.55-19.89h12.72Zm-12.32,0H452.21c-.43-2.74-.84-5.34-1.22-7.68-1.28-8-1.76-11.07-2-12.21h14Zm.4,5.15L466.59,430H456.41c-.34-2.18-.69-4.38-1-6.59L453,408.53ZM455.72,430h-6.65l-3.6-21.48h6.87C453.39,415.17,454.55,422.56,455.72,430Zm.81,5.15c1,6.46,2,12.82,2.92,18.66h-6.38l-3.13-18.66Zm32,18.66.62-18.66h6.8l-1.59,18.66Zm1.68-50.44.66-19.89h9.5l-1.7,19.89Zm-41.87-19.89c.27,1.44,1.53,9.27,3.21,19.89h-6.91l-3.34-19.89Zm52,70.33H495l1.6-18.66h5.92Zm5.92-50.44h-6.94l1.7-19.89h7.57Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M709.34,463.14c0,.14-151.92.26-339.28.26s-339.31-.12-339.31-.26,151.89-.26,339.31-.26S709.34,463,709.34,463.14Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--cleaning-trolley--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M263.57,219.41h.27a2.25,2.25,0,0,1,2.25,2.25V405.78a0,0,0,0,1,0,0h-4.76a0,0,0,0,1,0,0V221.66A2.25,2.25,0,0,1,263.57,219.41Z",
    style: {
      fill: "#3270F9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.28,230.5h.27a2.25,2.25,0,0,1,2.25,2.25V416.86a0,0,0,0,1,0,0H272a0,0,0,0,1,0,0V232.74A2.25,2.25,0,0,1,274.28,230.5Z",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.88,284.32V280.7h-2v-4.21h14.29v1.89l-3.89.86s0,2.44,4,4.59a.58.58,0,0,1,.23.79h0a.59.59,0,0,1-.58.28c-1.19-.18-4.75-1-5.59-4.2h-1v3.62Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.27,285a46.05,46.05,0,0,0-2.12,5.4c-.76,2.41-3.14,11.14-3.87,13.83a6.4,6.4,0,0,0-.22,1.63v17a2,2,0,0,0,2,2h13.12a2,2,0,0,0,2-1.92l.43-15.8a8.2,8.2,0,0,0-1.54-5c-1.7-2.37-4.12-5.94-4-6.9.24-1.47.79-1,1-2.42s-.83-1.5-.67-3.05,1.56-1.31,1.64-2.46a7.59,7.59,0,0,0-.25-2.29Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.75,
    y: 283.19,
    width: 8.56,
    height: 2.8,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "225.24 318.14 208.06 318.14 208.06 309.31 225.54 309.31 225.24 318.14",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.3,280.7a33.81,33.81,0,0,1-8.37,0,33.81,33.81,0,0,1,8.37,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.48,283.27c-.14,0-.26-.58-.26-1.3s.12-1.29.26-1.29.26.58.26,1.29S215.62,283.27,215.48,283.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.21,283.27c-.14,0-.26-.58-.26-1.3s.12-1.29.26-1.29.26.58.26,1.29S216.36,283.27,216.21,283.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217,283.27c-.15,0-.27-.58-.27-1.3s.12-1.29.27-1.29.26.58.26,1.29S217.09,283.27,217,283.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.68,283.27c-.15,0-.26-.58-.26-1.3s.11-1.29.26-1.29.26.58.26,1.29S217.82,283.27,217.68,283.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.41,283.27c-.14,0-.26-.58-.26-1.3s.12-1.29.26-1.29.26.58.26,1.29S218.55,283.27,218.41,283.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.14,283.27c-.14,0-.26-.58-.26-1.3s.12-1.29.26-1.29.26.58.26,1.29S219.29,283.27,219.14,283.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.88,283.27c-.15,0-.26-.58-.26-1.3s.11-1.29.26-1.29.26.58.26,1.29S220,283.27,219.88,283.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.44,278.55c-.15,0-.26-.48-.26-1.06s.11-1.06.26-1.06.26.47.26,1.06S226.58,278.55,226.44,278.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.84,284.32V280.7h-2v-4.21h14.29v1.89l-3.89.86s0,2.44,4,4.59a.58.58,0,0,1,.23.79h0a.59.59,0,0,1-.58.28c-1.19-.18-4.75-1-5.59-4.2h-1v3.62Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.23,285a46.05,46.05,0,0,0-2.12,5.4c-.76,2.41-3.14,11.14-3.87,13.83a6.4,6.4,0,0,0-.22,1.63v17a2,2,0,0,0,2,2h13.12a2,2,0,0,0,2-1.92l.43-15.8a8.2,8.2,0,0,0-1.54-5c-1.7-2.37-4.12-5.94-4-6.9.24-1.47.79-1,.95-2.42s-.83-1.5-.67-3.05,1.56-1.31,1.64-2.46a7.59,7.59,0,0,0-.25-2.29Z",
    style: {
      fill: "#3270F9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238.71,
    y: 283.19,
    width: 8.56,
    height: 2.8,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "250.2 318.14 233.02 318.14 233.02 309.31 250.5 309.31 250.2 318.14",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.26,280.7a33.81,33.81,0,0,1-8.37,0,33.81,33.81,0,0,1,8.37,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.44,283.27c-.14,0-.26-.58-.26-1.3s.12-1.29.26-1.29.26.58.26,1.29S240.58,283.27,240.44,283.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.17,283.27c-.14,0-.26-.58-.26-1.3s.12-1.29.26-1.29.26.58.26,1.29S241.32,283.27,241.17,283.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.91,283.27c-.15,0-.27-.58-.27-1.3s.12-1.29.27-1.29.26.58.26,1.29S242.05,283.27,241.91,283.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.64,283.27c-.15,0-.26-.58-.26-1.3s.11-1.29.26-1.29.26.58.26,1.29S242.78,283.27,242.64,283.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.37,283.27c-.14,0-.26-.58-.26-1.3s.12-1.29.26-1.29.26.58.26,1.29S243.51,283.27,243.37,283.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.1,283.27c-.14,0-.26-.58-.26-1.3s.12-1.29.26-1.29.26.58.26,1.29S244.25,283.27,244.1,283.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.84,283.27c-.15,0-.26-.58-.26-1.3s.11-1.29.26-1.29.26.58.26,1.29S245,283.27,244.84,283.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.4,278.55c-.15,0-.26-.48-.26-1.06s.11-1.06.26-1.06.26.47.26,1.06S251.54,278.55,251.4,278.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "279.86 449.02 226.76 449.02 220.78 388.34 287.53 388.34 279.86 449.02",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.84,
    y: 388.34,
    width: 72.15,
    height: 4.45,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.51,392.79c0,.14-16.23.26-36.24.26s-36.24-.12-36.24-.26,16.22-.26,36.24-.26S290.51,392.64,290.51,392.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.22,389.59l32.8,22,2-4.93-32.71-21.75a2,2,0,0,0-2.94,1.09h0A3,3,0,0,0,255.22,389.59Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.61,387.41a1.24,1.24,0,1,1-1.21-1.48A1.38,1.38,0,0,1,257.61,387.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "201.71 449.02 136.56 449.02 129.23 388.34 211.13 388.34 201.71 449.02",
    style: {
      fill: "#3270F9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "284.03 451.56 129.23 451.56 129.23 431.51 285.31 431.25 284.03 451.56",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "272.71 327.92 198.9 327.92 198.9 307.87 282.11 307.61 272.71 327.92",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "287.88 296.05 200.22 433.13 204.4 443.06 295.24 301.01 287.88 296.05",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.62,
    y: 388.34,
    width: 88.52,
    height: 4.45,
    style: {
      fill: "#3270F9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.77,392.79c0,.14-19.9.26-44.45.26s-44.47-.12-44.47-.26,19.91-.26,44.47-.26S214.77,392.64,214.77,392.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.48,389.59l40.25,22,2.41-4.93L174,384.94a2.65,2.65,0,0,0-3.6,1.09h0A2.65,2.65,0,0,0,171.48,389.59Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 172.93,
    cy: 387.41,
    r: 1.49,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 139.75,
    cy: 457.25,
    r: 8.23,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.51,457.25a4.76,4.76,0,1,1-4.76-4.76A4.76,4.76,0,0,1,144.51,457.25Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 200.28,
    cy: 457.25,
    r: 8.23,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 200.28,
    cy: 457.25,
    r: 4.76,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 272.04,
    cy: 457.25,
    r: 8.23,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.38,451.56c0,.14-34,.26-76,.26s-76-.12-76-.26,34-.26,76-.26S281.38,451.42,281.38,451.56Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 272.04,
    cy: 457.25,
    r: 4.76,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.95,296h30.4a2.88,2.88,0,0,1,2.88,2.88v.34a2.88,2.88,0,0,1-2.88,2.88h-30.4a0,0,0,0,1,0,0V296A0,0,0,0,1,287.95,296Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.44,
    y: 219.41,
    width: 46.21,
    height: 6.26,
    style: {
      fill: "#3270F9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.44,219.41s.47-10-.89-12.52h20.12l1.65,4.45,1.05-4.45H267V211l3.28-3.29H288a57.3,57.3,0,0,0-1.3,11.75Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.76,225.62c0,.15-10.39.26-23.2.26s-23.19-.11-23.19-.26,10.38-.26,23.19-.26S286.76,225.48,286.76,225.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.64,210.52s-.06-.11-.09-.34h.19c.09.69.16,2.42.16,4.44a21.72,21.72,0,0,1-.26,4.78,22.47,22.47,0,0,1-.26-4.78,41.48,41.48,0,0,1,.17-4.44h.19C250.71,210.41,250.68,210.52,250.64,210.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.13,215.82a32.85,32.85,0,0,1,0-8.25,32.85,32.85,0,0,1,0,8.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.27,212.55a24.78,24.78,0,0,1,0,7.16,24.78,24.78,0,0,1,0-7.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.55,215.82a31.67,31.67,0,0,1,0-8.1,31.67,31.67,0,0,1,0,8.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.13,310.75c-.09-2.19-.16-3-1.64-4.57-1.3-1.41-4.25-1.48-6.16-1.27a30.37,30.37,0,0,0-7,2.18c-.72,10.72-.66,21.27-1.38,32-.13,2-.19,4.34,1.19,5.86,1.84,2,5.06,1.53,7.71.9s5.72-1.58,6.83-4.1a10.24,10.24,0,0,0,.46-4.06C268.23,328.59,268.47,319.32,268.13,310.75Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--picture-2--inject-7"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 593.68,
    y: 60.85,
    width: 107.09,
    height: 138.31,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.77,60.85a1.92,1.92,0,0,1-.29.37l-.92,1-3.62,4,0,0h-.07c-9.31.1-27.6.16-48.6.16s-39.3-.06-48.61-.16h-.07l0,0-3.62-4-.92-1a1.92,1.92,0,0,1-.29-.37,2,2,0,0,1,.35.32l1,1L598.73,66l-.11,0c9.31-.1,27.6-.16,48.61-.16s39.29.06,48.6.16l-.11,0,3.72-3.87,1-1A2,2,0,0,1,700.77,60.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.68,199.16a2.38,2.38,0,0,1,.29-.37l.92-1,3.62-4,0,0h.07c9.31-.09,27.6-.16,48.6-.16s39.3.07,48.61.16h.07l0,0,3.62,4,.92,1a2.38,2.38,0,0,1,.29.37,1.68,1.68,0,0,1-.35-.31l-1-1c-.88-.91-2.12-2.21-3.72-3.86l.11.05c-9.31.09-27.6.15-48.61.15s-39.29-.06-48.6-.15l.11-.05L595,197.86l-1,1A1.68,1.68,0,0,1,593.68,199.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 598.62,
    y: 66.12,
    width: 97.21,
    height: 127.78,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.83,156.53c2.89-2.76,7.16-3.54,11.15-3.44s7.95.95,11.94.9c6.39-.08,12.75-2.45,19.05-1.35,2,.34,4,1,6,.62,1.75-.38,3.22-1.57,4.93-2.08,4.44-1.32,9.42,2.15,13.68.34V180H613.83Z",
    style: {
      fill: "#3270F9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.18,157.67c-.17,0-.31-16.89-.31-37.73s.14-37.73.31-37.73.31,16.89.31,37.73S615.35,157.67,615.18,157.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.22,157.67c-.17,0-.31-16.89-.31-37.73s.14-37.73.31-37.73.31,16.89.31,37.73S618.39,157.67,618.22,157.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.26,157.67c-.17,0-.31-16.89-.31-37.73s.14-37.73.31-37.73.31,16.89.31,37.73S621.43,157.67,621.26,157.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.3,157.67c-.17,0-.31-16.89-.31-37.73s.14-37.73.31-37.73.31,16.89.31,37.73S624.47,157.67,624.3,157.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.34,157.67c-.17,0-.31-16.89-.31-37.73s.14-37.73.31-37.73.31,16.89.31,37.73S627.51,157.67,627.34,157.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.38,157.67c-.17,0-.31-16.89-.31-37.73s.14-37.73.31-37.73.31,16.89.31,37.73S630.55,157.67,630.38,157.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.42,157.67c-.17,0-.31-16.89-.31-37.73s.14-37.73.31-37.73.31,16.89.31,37.73S633.59,157.67,633.42,157.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.46,157.67c-.17,0-.31-16.89-.31-37.73s.14-37.73.31-37.73.31,16.89.31,37.73S636.63,157.67,636.46,157.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.5,157.67c-.17,0-.31-16.89-.31-37.73s.14-37.73.31-37.73.31,16.89.31,37.73S639.67,157.67,639.5,157.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.54,157.67c-.17,0-.31-16.89-.31-37.73s.14-37.73.31-37.73.31,16.89.31,37.73S642.72,157.67,642.54,157.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.58,157.67c-.17,0-.31-16.89-.31-37.73s.14-37.73.31-37.73.32,16.89.32,37.73S645.76,157.67,645.58,157.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.63,157.67c-.18,0-.31-16.89-.31-37.73s.13-37.73.31-37.73.31,16.89.31,37.73S648.8,157.67,648.63,157.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.67,157.67c-.17,0-.31-16.89-.31-37.73s.14-37.73.31-37.73.31,16.89.31,37.73S651.84,157.67,651.67,157.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.71,157.67c-.17,0-.31-16.89-.31-37.73s.14-37.73.31-37.73.31,16.89.31,37.73S654.88,157.67,654.71,157.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.75,157.67c-.17,0-.31-16.89-.31-37.73s.14-37.73.31-37.73.31,16.89.31,37.73S657.92,157.67,657.75,157.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.79,157.67c-.17,0-.31-16.89-.31-37.73s.14-37.73.31-37.73.31,16.89.31,37.73S661,157.67,660.79,157.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.83,157.67c-.17,0-.31-16.89-.31-37.73s.14-37.73.31-37.73.31,16.89.31,37.73S664,157.67,663.83,157.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.87,157.67c-.17,0-.31-16.89-.31-37.73s.14-37.73.31-37.73.31,16.89.31,37.73S667,157.67,666.87,157.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.91,157.67c-.17,0-.31-16.89-.31-37.73s.14-37.73.31-37.73.31,16.89.31,37.73S670.08,157.67,669.91,157.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673,157.67c-.17,0-.31-16.89-.31-37.73s.14-37.73.31-37.73.31,16.89.31,37.73S673.12,157.67,673,157.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676,157.67c-.17,0-.31-16.89-.31-37.73s.14-37.73.31-37.73.31,16.89.31,37.73S676.16,157.67,676,157.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679,157.67c-.17,0-.31-16.89-.31-37.73s.14-37.73.31-37.73.31,16.89.31,37.73S679.21,157.67,679,157.67Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--picture-1--inject-7"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 175.87,
    y: 24.8,
    width: 155.59,
    height: 182.43,
    transform: "translate(137.65 369.68) rotate(-90)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.81,
    y: 27.67,
    width: 149.72,
    height: 176.68,
    transform: "translate(137.65 369.68) rotate(-90)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.78,
    y: 34.12,
    width: 138.37,
    height: 163.29,
    transform: "translate(138.2 369.72) rotate(-90)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.05,89.68l-13.89,1a3.62,3.62,0,0,0-2.26.7c-.82.78-.71,2.1-.53,3.22q3.34,21.17,6.7,42.34l20.06,3.31c-1.65-15.72-3.5-30.37-6.06-47.6a3.92,3.92,0,0,0-.84-2.25C205.45,89.58,204.17,89.6,203.05,89.68Z",
    style: {
      fill: "#3270F9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.92,158.86c.62,8.21,6.12,15.62,13.33,19.6s15.89,4.79,24,3.37c5.62-1,11.32-3.18,14.91-7.62,3.36-4.17,4.41-9.81,4.14-15.16-.48-9.54-5.56-19.4-14.41-23-4.91-2-10.4-1.9-15.69-1.46-5.56.46-11.26,1.31-16,4.2a22.6,22.6,0,0,0-10.25,20.06",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.67,58.23c-9.24,3-15.52,17.79-16.6,27.46s1,19.36,1.6,29.07-.78,20.28-7.41,27.39c-8,8.57-21.54,9.9-29.83,18.19A24.07,24.07,0,0,0,278,185.11h58Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.85,172.46s34.1-14,38-16.79,11.11-8.53,23-29.71l93.26,6.46-7.74,37.44L178.4,179.69Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.83,57.72a53.69,53.69,0,0,0-10.73,3.51,25.88,25.88,0,0,0-6.38,4.29h0a26.43,26.43,0,0,0-8.23,14.78c-.13.75-.24,1.52-.3,2.29-.35,4.41.84,9.18,4.14,12.12,2.58,2.31,6.08,3.23,9.45,4,14.75,3.53,29.76,6.27,44.92,6.74,6.7.21,13.51,0,20-1.9s12.56-5.48,16.43-11,5.2-13,2.46-19.08c-2.67-6-8.58-9.81-14.56-12.46C278.22,53.24,257.74,53.25,238.83,57.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.32,46.58V87.26l74.76-40.68C223.65,46.59,172.32,46.58,172.32,46.58Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.75,109.08c-2.88,1.57-5.9,3.19-9.17,3.27-4.39.11-8.32-2.51-11.91-5l-14.83-10.4c-2.08-1.46-4.28-3-6.8-3.26-3.89-.47-7.2,1.94-10,5a5.8,5.8,0,0,0-.48,7.21c10.21,14.68,21.37,29.7,31.4,44.32,1.42,2,2.93,4.2,5.19,5.25,2.51,1.17,5.44.76,8.17.32,18.69-3,54.31-12.3,54.31-12.3l-.07-63.29S301.56,102.6,289.75,109.08Z",
    style: {
      fill: "#3270F9"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-3--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M420.93,463.05l59-62.32c20.33-21.48,41-42.69,61-64.45,11.08-12,27.65-15.1,41.72-6,6.85,4.4,13.55,9.07,20.32,13.6,4,2.69,7.78-3.81,3.79-6.48-6.6-4.42-13.17-8.88-19.8-13.25a39.39,39.39,0,0,0-38.72-2.92c-9.95,4.74-18,15.52-25.54,23.45q-41.61,44-83.21,87.89l-23.89,25.23c-3.32,3.5,2,8.81,5.3,5.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.47,329.22a16.82,16.82,0,0,1-2.69-3.06,15.69,15.69,0,0,1-2.29-3.38,32.25,32.25,0,0,1,5,6.44Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.58,335a15.48,15.48,0,0,1-2.7-3.06,16.23,16.23,0,0,1-2.28-3.37,16.25,16.25,0,0,1,2.7,3.06A15.85,15.85,0,0,1,542.58,335Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.68,341a15.66,15.66,0,0,1-3.33-2.35,16,16,0,0,1-3-2.76,32.52,32.52,0,0,1,6.33,5.11Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530,348.05a16.62,16.62,0,0,1-3.17-2.56,15.7,15.7,0,0,1-2.81-2.95,32.16,32.16,0,0,1,6,5.51Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524,354.83a15.53,15.53,0,0,1-3.17-2.56,16.4,16.4,0,0,1-2.82-2.95,15.57,15.57,0,0,1,3.17,2.57A16.42,16.42,0,0,1,524,354.83Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.65,361.07a16.45,16.45,0,0,1-3.17-2.57,15.7,15.7,0,0,1-2.81-2.95,16.2,16.2,0,0,1,3.17,2.57A16.42,16.42,0,0,1,517.65,361.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.15,367.11a16.45,16.45,0,0,1-3.17-2.57,15.83,15.83,0,0,1-2.81-2.94,16.36,16.36,0,0,1,3.17,2.56A16,16,0,0,1,512.15,367.11Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.77,373.79a16.45,16.45,0,0,1-3.17-2.57,15.7,15.7,0,0,1-2.81-3,17.17,17.17,0,0,1,3.17,2.57A15.58,15.58,0,0,1,505.77,373.79Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.39,380.47a16.45,16.45,0,0,1-3.17-2.57,16.11,16.11,0,0,1-2.81-2.95,16.2,16.2,0,0,1,3.17,2.57A15.58,15.58,0,0,1,499.39,380.47Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493,387.14a16.16,16.16,0,0,1-3.18-2.56,16.54,16.54,0,0,1-2.81-2.95,15.88,15.88,0,0,1,3.17,2.57A16.05,16.05,0,0,1,493,387.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.64,393.82a15.8,15.8,0,0,1-3.17-2.57,16.94,16.94,0,0,1-2.82-2.94,15.71,15.71,0,0,1,3.17,2.56A16.28,16.28,0,0,1,486.64,393.82Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.26,400.5a32.24,32.24,0,0,1-6-5.52,15.77,15.77,0,0,1,3.18,2.57A16.42,16.42,0,0,1,480.26,400.5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.88,407.17a16.62,16.62,0,0,1-3.17-2.56,15.7,15.7,0,0,1-2.81-2.95,16.2,16.2,0,0,1,3.17,2.57A16.57,16.57,0,0,1,473.88,407.17Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.5,413.85a16.45,16.45,0,0,1-3.17-2.57,15.49,15.49,0,0,1-2.81-2.94,32.16,32.16,0,0,1,6,5.51Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.12,420.53A16.45,16.45,0,0,1,458,418a16.19,16.19,0,0,1-2.81-2.94,16.36,16.36,0,0,1,3.17,2.56A15.58,15.58,0,0,1,461.12,420.53Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.74,427.21a16.45,16.45,0,0,1-3.17-2.57,15.7,15.7,0,0,1-2.81-2.95,16.2,16.2,0,0,1,3.17,2.57A15.58,15.58,0,0,1,454.74,427.21Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.37,433.88a16.16,16.16,0,0,1-3.18-2.56,16.54,16.54,0,0,1-2.81-2.95,32.64,32.64,0,0,1,6,5.51Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442,440.56a15.8,15.8,0,0,1-3.17-2.57,16.54,16.54,0,0,1-2.82-2.94,15.71,15.71,0,0,1,3.17,2.56A16.28,16.28,0,0,1,442,440.56Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.61,447.24a15.8,15.8,0,0,1-3.17-2.57,16.4,16.4,0,0,1-2.82-2.95,16,16,0,0,1,3.17,2.57A16.28,16.28,0,0,1,435.61,447.24Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.23,453.92a32.24,32.24,0,0,1-6-5.52,15.77,15.77,0,0,1,3.18,2.57A16.42,16.42,0,0,1,429.23,453.92Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.9,326.06c-.15,0-.67-1.64-1.65-3.54s-2-3.31-1.92-3.41a8.42,8.42,0,0,1,2.38,3.17A8.52,8.52,0,0,1,556.9,326.06Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.53,317.55a9.88,9.88,0,0,1-.44,7.5c-.14,0,.33-1.67.44-3.73S564.38,317.58,564.53,317.55Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 383.35,
    y: 457.73,
    width: 60.83,
    height: 7.27,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.36,457.73c0,.14-13.7.26-30.58.26s-30.58-.12-30.58-.26,13.69-.26,30.58-.26S444.36,457.58,444.36,457.73Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.3,465.24a26.31,26.31,0,0,1,0-7.38,26.31,26.31,0,0,1,0,7.38Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.56,351.16c2.73,6.18,6.8,11.81,10.84,17.19a198.61,198.61,0,0,0,13.3,16.1c6.28,6.74,13,13.09,19,20.08,5.24,6.07,10.38,13.37,13.24,20.74a50.53,50.53,0,0,1,1.94,6.08c.23.9.42,1.8.59,2.7.07.39.14.79.2,1.18,0,.23.07.46.1.68-.08-.55,0-.06,0,.23a52,52,0,0,1,.11,10.87c0,.5-.11,1-.17,1.5.08-.61-.09.51-.11.67-.15.92-.33,1.84-.55,2.75a38.24,38.24,0,0,1-1.61,5.21c-.05.1-.3.65,0,.08-.07.16-.14.32-.22.48-.17.37-.35.74-.54,1.1a24.31,24.31,0,0,1-1.39,2.36c-.1.16-.68,1-.49.71s-.09.12-.12.15l-.43.51a19,19,0,0,1-1.91,1.9l-.38.33c-.08.06-.63.5-.29.24s-.13.09-.16.11l-.55.39c-.71.48-1.45.92-2.2,1.33-.36.19-.71.37-1.08.54l-.63.29c.15-.07.63-.24-.06,0s-1.63.6-2.47.84-1.69.45-2.55.61l-1,.18c.73-.12-.72.07-.91.08a28.33,28.33,0,0,1-5.21-.07l.15,0-.68-.11-1.17-.24a22.81,22.81,0,0,1-2.45-.69c-.15-.06-1.36-.55-.67-.24-.36-.16-.7-.33-1-.52a9.77,9.77,0,0,1-.95-.63c.58.44-.31-.32-.47-.48a9.93,9.93,0,0,1-.86-1c.41.54-.15-.27-.27-.45s-.39-.67-.57-1c-.07-.15-.14-.3-.22-.45-.18-.38.15.47-.08-.19a19.87,19.87,0,0,1-.67-2.28c0-.16-.25-1.49-.16-.69,0-.45-.09-.91-.11-1.37a21,21,0,0,1,.06-2.38c0-.74,0-.16,0,0,0-.24.08-.47.13-.71.1-.5.22-1,.37-1.5a9.22,9.22,0,0,1,.76-2,20.5,20.5,0,0,1,1.6-2.65l.34-.47c.39-.51-.28.33.14-.16s.59-.7.9-1a25.64,25.64,0,0,1,2.11-2.06,13.93,13.93,0,0,1,1.87-1.48,23.61,23.61,0,0,1,2.64-1.58,11.14,11.14,0,0,1,2.2-.93,23.71,23.71,0,0,1,2.77-.79q.64-.15,1.29-.27l.74-.13s.63-.09.24,0l1-.11c.54,0,1.09-.09,1.63-.11a80.49,80.49,0,0,1,9.82.3c1.31.1,2.61.19,3.93.19a3.75,3.75,0,0,0,0-7.5c-3.12,0-6.23-.41-9.34-.52a42.71,42.71,0,0,0-12,1.13c-8.66,2.23-16.61,8.9-19.59,17.44-2.66,7.65-.37,17.7,6.76,22.14,3.38,2.11,7.73,2.93,11.65,3.11A30.79,30.79,0,0,0,650,475.28a28.53,28.53,0,0,0,10.38-6.23,28,28,0,0,0,6.45-10.25c2.84-7.35,3.37-15.77,2.37-23.54-2.52-19.36-15.89-34.19-29-47.62-5.66-5.8-11.21-11.62-16.3-17.93-.58-.72-1.16-1.44-1.73-2.17-.77-1-.74-.93-1.49-1.92q-1.83-2.4-3.58-4.86a105.53,105.53,0,0,1-6-9.25c-.76-1.35-1.47-2.72-2.1-4.14-.81-1.85-3.52-2.28-5.13-1.34-1.91,1.11-2.16,3.27-1.34,5.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.59,441.79a39.42,39.42,0,0,1,0-9,39.42,39.42,0,0,1,0,9Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.32,440.33a23.55,23.55,0,0,1,0-7,23.55,23.55,0,0,1,0,7Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.45,440.7a11.37,11.37,0,0,1-.88-3.38,11.83,11.83,0,0,1-.37-3.48,11.73,11.73,0,0,1,.88,3.38A12.25,12.25,0,0,1,643.45,440.7Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.27,442.56a12.19,12.19,0,0,1-1.62-3.11,11.8,11.8,0,0,1-1.13-3.31,12.36,12.36,0,0,1,1.61,3.11A12,12,0,0,1,638.27,442.56Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.54,445.18a11.44,11.44,0,0,1-2.38-2.56,11.74,11.74,0,0,1-2-2.89,11.91,11.91,0,0,1,2.38,2.57A12.16,12.16,0,0,1,633.54,445.18Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.72,448.75a12.39,12.39,0,0,1-3-1.84,11.77,11.77,0,0,1-2.68-2.26,12.13,12.13,0,0,1,3,1.84A11.58,11.58,0,0,1,629.72,448.75Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.39,452.8a12,12,0,0,1-3.29-1.14,11.48,11.48,0,0,1-3.08-1.61,12.08,12.08,0,0,1,3.29,1.13A11.34,11.34,0,0,1,627.39,452.8Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.11,458a12.17,12.17,0,0,1-3.48.07,12,12,0,0,1-3.45-.44,11.54,11.54,0,0,1,3.48-.08A11.36,11.36,0,0,1,626.11,458Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.18,463.14a12.09,12.09,0,0,1-3.42.93,12.47,12.47,0,0,1-3.53.42,11.84,11.84,0,0,1,3.43-.93A12,12,0,0,1,627.18,463.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.26,466.48a12.53,12.53,0,0,1-3,1.85,12.26,12.26,0,0,1-3.27,1.38,12.28,12.28,0,0,1,3-1.85A12.12,12.12,0,0,1,629.26,466.48Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.58,468.52a24.48,24.48,0,0,1-4,5.88,23.73,23.73,0,0,1,4-5.88Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.6,469.51a12.26,12.26,0,0,1-.3,3.54,12.43,12.43,0,0,1-.82,3.46,11.85,11.85,0,0,1,.3-3.54A12.43,12.43,0,0,1,637.6,469.51Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.22,469.52a12.36,12.36,0,0,1,.85,3.44,12.59,12.59,0,0,1,.35,3.54,24,24,0,0,1-1.2-7Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.16,467.81a12,12,0,0,1,1.52,3.21,12.64,12.64,0,0,1,1,3.4,24,24,0,0,1-2.55-6.61Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.4,464.74a11.79,11.79,0,0,1,2.45,2.56,12.09,12.09,0,0,1,2,2.9,12.09,12.09,0,0,1-2.45-2.56A12.45,12.45,0,0,1,654.4,464.74Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.73,460.78a24.08,24.08,0,0,1,6.35,3.13,11.84,11.84,0,0,1-3.29-1.33A12.1,12.1,0,0,1,657.73,460.78Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.15,456a12.54,12.54,0,0,1,3.42,1,11.83,11.83,0,0,1,3.24,1.45,12.3,12.3,0,0,1-3.42-1A12,12,0,0,1,660.15,456Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.31,451.37a11.69,11.69,0,0,1,3.54.22,12.59,12.59,0,0,1,3.48.74,24,24,0,0,1-7-1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662.31,446.22a12.33,12.33,0,0,1,3.54.23,12.46,12.46,0,0,1,3.47.74,12.52,12.52,0,0,1-3.54-.22A11.85,11.85,0,0,1,662.31,446.22Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662.38,441.62a24.23,24.23,0,0,1,7.08,0,24.23,24.23,0,0,1-7.08,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.9,436.13a24.23,24.23,0,0,1,7.08,0,24.23,24.23,0,0,1-7.08,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661,430.83a11.8,11.8,0,0,1,3.48-.7A12.43,12.43,0,0,1,668,430a12.19,12.19,0,0,1-3.48.7A12.43,12.43,0,0,1,661,430.83Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.37,425.88a12.36,12.36,0,0,1,3.4-1,12.61,12.61,0,0,1,3.51-.52,12.36,12.36,0,0,1-3.4,1A12.18,12.18,0,0,1,659.37,425.88Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.24,420.83a24.6,24.6,0,0,1,6.91-1.54,24.6,24.6,0,0,1-6.91,1.54Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.68,416.1a12.1,12.1,0,0,1,3.3-1.32,12,12,0,0,1,3.45-.83,12.12,12.12,0,0,1-3.29,1.32A12,12,0,0,1,654.68,416.1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.27,411.07a12.79,12.79,0,0,1,3.24-1.46,12.43,12.43,0,0,1,3.41-1,24.3,24.3,0,0,1-6.65,2.43Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.23,405.5a12,12,0,0,1,3.23-1.46,12.37,12.37,0,0,1,3.42-1,12,12,0,0,1-3.24,1.46A12.35,12.35,0,0,1,647.23,405.5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.78,400.64a11.84,11.84,0,0,1,2.91-2,12.55,12.55,0,0,1,3.17-1.59,11.84,11.84,0,0,1-2.91,2A12.55,12.55,0,0,1,642.78,400.64Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.6,395.22a24.62,24.62,0,0,1,6.08-3.62,12.29,12.29,0,0,1-2.9,2A11.9,11.9,0,0,1,637.6,395.22Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.64,390a12.3,12.3,0,0,1,2.91-2,12.16,12.16,0,0,1,3.17-1.59,12.3,12.3,0,0,1-2.91,2A12.16,12.16,0,0,1,632.64,390Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.38,384.6a12.09,12.09,0,0,1,2.91-2,12.35,12.35,0,0,1,3.18-1.59,12.09,12.09,0,0,1-2.91,2A12.35,12.35,0,0,1,627.38,384.6Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623,379.85a12.42,12.42,0,0,1,2.91-2,12.55,12.55,0,0,1,3.17-1.59,11.65,11.65,0,0,1-2.9,2A12.52,12.52,0,0,1,623,379.85Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.22,374.16a24.62,24.62,0,0,1,6.08-3.62,12.29,12.29,0,0,1-2.9,2A11.9,11.9,0,0,1,618.22,374.16Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.06,369a12.57,12.57,0,0,1,2.91-2,12.35,12.35,0,0,1,3.18-1.59,12.57,12.57,0,0,1-2.91,2A11.61,11.61,0,0,1,614.06,369Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.9,363.78a12.57,12.57,0,0,1,2.91-2,12,12,0,0,1,3.18-1.59,12.57,12.57,0,0,1-2.91,2A11.61,11.61,0,0,1,609.9,363.78Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.56,221.74c-.33-2.52-2.19-4.52-3.83-6.47a51.15,51.15,0,0,1-8.14-13.52c-1.27-3.14-2.33-6.54-4.83-8.82s-7.09-2.68-8.91.17l-4.08,7,10.07,27.54c1.27,3.48,3.14,7.48,6.79,8.12s6.8-2.57,9.16-5.47C561.82,227.81,564,224.92,563.56,221.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529,190.46a23.77,23.77,0,0,0-20.22,3.73c-3.38,2.46-4.24,4.19-6.16,6.65a13.18,13.18,0,0,0-3,8.5A22.12,22.12,0,0,0,502.24,220a62.31,62.31,0,0,0,6.4,9.43,20.8,20.8,0,0,0,9.27,6.41l8.72-4.46c4.37-3.05,8.8-6.16,12.22-10.25s5.78-9.36,5.27-14.67C543.41,199.1,536.24,192.23,529,190.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.13,195.57l-13.36,3.64-2.45,2.33c-6,4.57-5.19,14.37-1.55,19.3,4,5.48,9.2,12,13.08,15.37,7.8,6.76,15.19,2.25,15.19,2.25L537,244l1,6.33,14,17.12,13.69-8.13-12.09-28.1L551.76,230l-2.86-3.62-22-30.11A3.59,3.59,0,0,0,522.13,195.57Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.53,225.23a2.14,2.14,0,0,0-1.39-.62,2.2,2.2,0,0,0-2.22,1.48,2.94,2.94,0,0,0,.76,2.88h0a2.73,2.73,0,0,0,2.2-.26l.29-.21a2.38,2.38,0,0,0,.91-1.48A2.14,2.14,0,0,0,528.53,225.23Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.7,225.57a1.29,1.29,0,0,0,1.81.2,1.25,1.25,0,0,0,.28-1.77,1.32,1.32,0,0,0-1.82-.2A1.25,1.25,0,0,0,512.7,225.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.66,222.18c.23,0,.52-1.17,1.6-2.08s2.32-1,2.32-1.25-.31-.24-.87-.2a3.59,3.59,0,0,0-2,.84,3.47,3.47,0,0,0-1.13,1.82C508.46,221.84,508.55,222.17,508.66,222.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.49,225.56a9.34,9.34,0,0,0-2,1.16c-.3.2-.61.37-.81.22a1.83,1.83,0,0,1-.5-1c-.31-.89-.62-1.81-.95-2.78-1.38-3.93-2.62-7.07-2.78-7s.83,3.29,2.21,7.22q.51,1.44,1,2.76a2.13,2.13,0,0,0,.76,1.2.91.91,0,0,0,.79,0,2.55,2.55,0,0,0,.53-.33A8.73,8.73,0,0,0,522.49,225.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533,238.46a25.89,25.89,0,0,0,8.1-11.57s1.77,7.75-6.66,13.59Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.29,223.64c-.19.14.79,1.31.49,3s-1.65,2.59-1.53,2.76.47,0,1-.43a3.86,3.86,0,0,0,1.33-2.24,3.33,3.33,0,0,0-.49-2.43C526.73,223.75,526.36,223.57,526.29,223.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.08,218c.41.11,1.08-.76,2.11-1.49s2-1.15,2.06-1.56c0-.2-.33-.37-.88-.35A4,4,0,0,0,506,217C505.83,217.54,505.9,217.9,506.08,218Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.51,215.83a1.32,1.32,0,0,1-.18,1.82,1.25,1.25,0,0,1-1.79-.11,1.31,1.31,0,0,1,.18-1.81A1.25,1.25,0,0,1,524.51,215.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.53,210.32c0,.24-1.26.27-2.37,1.14s-1.48,2-1.71,2-.16-.36,0-.89a3.58,3.58,0,0,1,1.24-1.78,3.43,3.43,0,0,1,2-.73C523.24,210.06,523.54,210.21,523.53,210.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.15,207.23c0,.43-1.08.83-2.12,1.62s-1.77,1.65-2.18,1.54c-.19-.06-.25-.41-.05-.95a4.1,4.1,0,0,1,1.39-1.75,4,4,0,0,1,2.07-.8C519.83,206.87,520.15,207,520.15,207.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.81,211c-.49-.58-1-2.51-.47-3.09,1.33-1.52,4.2-3.72,7.49.15,4.51,5.29-1.73,8.72-1.87,8.58S537.49,213,535.81,211Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.77,213.47s.15,0,.37-.07a1.23,1.23,0,0,0,.7-.58,3,3,0,0,0-.69-2.94,4,4,0,0,0-1.38-1.1,1.41,1.41,0,0,0-1.3-.12.63.63,0,0,0-.33.72c.06.21.18.28.16.32s-.19,0-.33-.25a.74.74,0,0,1-.07-.51.9.9,0,0,1,.39-.57,1.69,1.69,0,0,1,1.66,0,4.16,4.16,0,0,1,1.58,1.2c.87,1.1,1.18,2.56.6,3.43a1.27,1.27,0,0,1-1,.58C540.89,213.59,540.76,213.5,540.77,213.47Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.58,207.77l-.31,2.52c-10.47-1.25-33.32-6.9-32-6.53a22.14,22.14,0,0,1,8-7.48c5.1-2.62,15.38-6.81,19.26-1.37S535.58,207.77,535.58,207.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 668.66,
    y: 395.95,
    width: 62.5,
    height: 5.69,
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 668.66,
    y: 395.95,
    width: 62.5,
    height: 48.3,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 668.66,
    y: 395.95,
    width: 62.5,
    height: 5.69,
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M727,370.82v-4.89a6.57,6.57,0,0,0-6.57-6.57H684.38s-12.52,13.8-12.73,14.86S666.34,396,666.34,396h67.28V380.18a9.24,9.24,0,0,0-4.06-7.65Zm-5.24-2.49H705.16l-5.95-5.28h19.21a3.39,3.39,0,0,1,3.38,3.38Z",
    style: {
      fill: "#3270F9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683.43,459.1a6.1,6.1,0,1,1-6.1-6.11A6.1,6.1,0,0,1,683.43,459.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M726.34,459.1a6.11,6.11,0,1,1-6.1-6.11A6.1,6.1,0,0,1,726.34,459.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 666.34,
    y: 444.25,
    width: 66.88,
    height: 9.87,
    style: {
      fill: "#3270F9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.57,298.11c1,1.29,9.69,18.48,8.07,28.12s-13.15,20.23-17.37,28.61c-4,8.06-22.33,32.26-23,41.35s-8.71,36.21-15.49,55.25l-1.7,4.6-16.7-2.34s7.1-26.14,9.36-36.8.15-12.61,1.94-20.71S557.57,367,557.57,367l15-45.36-1.82-15.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.59,301s9,10.61,9.2,23.1-4.57,15.64-4.95,25.57-4.74,21.79-3.28,33.41,8,14,8.24,28.08S614.56,453,614.56,453l-14.6-.35s-3.17-33.37-2.93-36.52-.74-7.42-4.37-16.86-5.62-11.88-5.38-23.74S591.64,314,591.64,314l1.94-13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.49,365.79a3,3,0,0,1,.25-.58c.21-.42.47-1,.81-1.62.72-1.41,1.78-3.43,3.17-5.88s3.1-5.35,5.19-8.45,4.87-6.15,7.15-9.77a41.5,41.5,0,0,0,5.21-10.82,29.16,29.16,0,0,0,1-9.72,18.58,18.58,0,0,0-1.49-6.42c-.67-1.41-1.25-2.08-1.2-2.12a8.57,8.57,0,0,1,1.38,2,18,18,0,0,1,1.68,6.48,28.87,28.87,0,0,1-.91,9.88,40.74,40.74,0,0,1-5.23,11c-2.31,3.67-5.16,6.66-7.19,9.76s-3.83,5.94-5.27,8.36-2.54,4.42-3.31,5.79l-.9,1.58A3.16,3.16,0,0,1,591.49,365.79Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.71,441.11l.73,15.3s-15.07,5.9-15.21,8.74l29.28-.38-.18-23.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.48,455a1.2,1.2,0,0,1,.84,1.37,1.14,1.14,0,0,1-1.33.86,1.28,1.28,0,0,1-.89-1.46,1.2,1.2,0,0,1,1.49-.74",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.51,464.77l-.11-2.41-28,1.27s-1.3.59-1.14,1.52Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600,456.27c0,.14.72.2,1.43.66s1.09,1.06,1.22,1-.09-.9-1-1.43S599.93,456.13,600,456.27Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.91,457.6c0,.14.59.38,1.09,1s.64,1.26.78,1.25.22-.83-.41-1.57S596.91,457.46,596.91,457.6Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.21,461.35c.13,0,.32-.7-.05-1.49s-1-1.1-1.11-1,.36.54.66,1.19S595.07,461.34,595.21,461.35Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.3,440.43l-4.8,15.64s-15.68,6.13-15.82,9.09l30.44-.4,0-7.11,3.84-15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.12,464.76v-2.37l-29.25,1.18s-1.35.62-1.18,1.59Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.4,456.17c0,.15.75.21,1.48.68s1.14,1.11,1.28,1-.1-.94-1-1.5S539.36,456,539.4,456.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.94,457.59c0,.14.61.39,1.12,1s.67,1.31.82,1.3.23-.86-.42-1.64S535.94,457.44,535.94,457.59Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534,461.56c.13,0,.33-.73-.06-1.55s-1.1-1.14-1.16-1,.38.57.69,1.24S533.83,461.54,534,461.56Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.48,344.91a5.58,5.58,0,0,1-.05,1.12c-.07.72-.19,1.75-.35,3-.33,2.55-.86,6.05-1.49,9.91L610,368.84l-.51,3a5.5,5.5,0,0,1-.25,1.09,4.17,4.17,0,0,1,0-1.12c.06-.72.18-1.75.34-3,.33-2.55.86-6.05,1.49-9.91s1.21-7.23,1.65-9.88l.51-3A4.16,4.16,0,0,1,613.48,344.91Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.62,228.1s11.49.23,19.54,8.27,27.37,39.76,27.7,44.59a58.06,58.06,0,0,1,0,8.5L610.77,301s-7.82,4.58-16.55,4.58S568.71,301,568.71,301l-4.6-9.67-22.75-16.55s-7.36-20.91-4.83-28S552.62,228.1,552.62,228.1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 658.59,
    y: 432.02,
    width: 9.78,
    height: 10.76,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "552.62 228.1 548.9 226.4 537.15 241.62 537.35 247.51 552.62 228.1",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.42,227.19a11.83,11.83,0,0,1-1.16,2.39,61.78,61.78,0,0,1-3.43,5.42,63.2,63.2,0,0,1-4,5.06A12.52,12.52,0,0,1,541,242a15.32,15.32,0,0,1,1.57-2.14c1-1.29,2.37-3.08,3.81-5.12s2.66-3.92,3.54-5.3A18.06,18.06,0,0,1,551.42,227.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.61,298.11c-.32,1.29,5.23,21.72,5.23,21.72l-16.85,70s9.36,8.71,33.25,5.81c0,0,14.85-58.11,15.49-73s-1.29-24.53-1.29-24.53L594.57,290s-19.69,0-29.05-3.55-19-11.62-19-11.62L536.79,252l-.39,3.58.75,17.07Z",
    style: {
      fill: "#3270F9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "594.57 290.04 599.86 289.46 602.54 292.29 597.73 298.11 594.57 290.04",
    style: {
      fill: "#3270F9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.23,291.93s0-.15.09-.43a11.46,11.46,0,0,1,.38-1.19,22.38,22.38,0,0,1,2-4.13,23.53,23.53,0,0,1,4.44-5.18,22.17,22.17,0,0,1,3.27-2.38,6.36,6.36,0,0,1,2-.88,2.61,2.61,0,0,1,2.27.57,2.25,2.25,0,0,1,.48,2.3,5,5,0,0,1-1.21,1.86,39.13,39.13,0,0,1-2.94,2.76,36.76,36.76,0,0,1-5.6,3.91,34.34,34.34,0,0,1-4.13,2c-.5.21-.9.35-1.17.44a2.27,2.27,0,0,1-.43.11,14.64,14.64,0,0,1,1.52-.73,45.05,45.05,0,0,0,4-2.13,39.25,39.25,0,0,0,5.46-3.95,38.66,38.66,0,0,0,2.88-2.75,4.29,4.29,0,0,0,1.09-1.66,1.73,1.73,0,0,0-.34-1.77,2.12,2.12,0,0,0-1.81-.44,6,6,0,0,0-1.86.81,23.18,23.18,0,0,0-3.22,2.3,24.31,24.31,0,0,0-6.59,9C600.46,291.37,600.27,291.94,600.23,291.93Z",
    style: {
      fill: "#3270F9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.57,292.24s-.12-.14-.3-.43-.43-.72-.73-1.29a41.11,41.11,0,0,1-2.25-5,43.52,43.52,0,0,1-2.11-7.84,14.21,14.21,0,0,1,0-4.83,7.29,7.29,0,0,1,.9-2.44,3.91,3.91,0,0,1,2.09-1.75,2.61,2.61,0,0,1,2.63.76,5.84,5.84,0,0,1,1.25,2.3,26.1,26.1,0,0,1,.81,4.75,29,29,0,0,1-.48,8.1,27.46,27.46,0,0,1-1.62,5.23c-.25.59-.47,1-.63,1.34s-.24.46-.26.45.26-.66.71-1.87a32.16,32.16,0,0,0,1.44-5.22,29.86,29.86,0,0,0,.36-8,26.79,26.79,0,0,0-.81-4.63,5.37,5.37,0,0,0-1.14-2.1,2.1,2.1,0,0,0-2.11-.62,3.39,3.39,0,0,0-1.8,1.52,6.84,6.84,0,0,0-.84,2.27,13.75,13.75,0,0,0,0,4.66,45,45,0,0,0,2,7.78,50.14,50.14,0,0,0,2.08,5C600.27,291.59,600.6,292.22,600.57,292.24Z",
    style: {
      fill: "#3270F9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.78,296.5a99.21,99.21,0,0,1-10,1.2,100.6,100.6,0,0,1-10.08.69,191.88,191.88,0,0,1,20.1-1.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M733,396c0,.14-14.87.26-33.2.26s-33.21-.12-33.21-.26,14.87-.26,33.21-.26S733,395.8,733,396Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M722.26,368.33c0,.14-8,.26-17.89.26s-17.88-.12-17.88-.26,8-.26,17.88-.26S722.26,368.19,722.26,368.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671.65,374.22S712,391.4,711.42,391.4H667Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.11,269.74c-.17.05-3.18,31.23-3.18,31.23l-9.65,27.8,7.58,9.88s13.58-25,15.3-34.45,8.38-37.38,8.38-37.38L543.66,261Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.49,241.12c-.9.14-8.27,2.3-9.49,8s-2.44,21.14-2.44,21.14,18.37-2.41,20-.69,3.22-17.51,3.22-17.51S551.73,240.16,545.49,241.12Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.28,325.51c0,.92-12.64,31.07-12.87,33.6s-5.52,10.57-3.22,12.87,6.38-8.51,6.38-8.51,1,3.22,4,2.53,2.07-2.76,2.07-2.76a23.46,23.46,0,0,0,5.39-3.67c2.43-2.3,2.85-11.44,2.85-12.75s7.48-15.3,7.48-15.3C528.56,332.23,526.06,330.8,522.28,325.51Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.89,358.16c.08,0,.12.37.16.93a8.94,8.94,0,0,0,.35,2.13,3.47,3.47,0,0,0,1.18,1.68c.44.31.79.39.77.47s-.4.12-1-.16a3.23,3.23,0,0,1-1.49-1.82,5.75,5.75,0,0,1-.22-2.3C516.74,358.51,516.82,358.16,516.89,358.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.49,358.39c.07,0,.1.15.08.35a1.51,1.51,0,0,1-.07.33l0,.18c0,.05,0,.12,0,0s0,0,0,0l.15.11a1.18,1.18,0,0,1,.26.21c.14.15.2.27.16.32s-.17.05-.35,0l-.3-.12-.19-.08c-.06-.06-.16-.06-.26-.28a.51.51,0,0,1,0-.37l.09-.18a1.74,1.74,0,0,1,.16-.28C522.33,358.46,522.42,358.37,522.49,358.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.35,244.06a15.35,15.35,0,0,0-2.63-2.48,11.75,11.75,0,0,0-8.26-1.87,15.13,15.13,0,0,0-7.69,3.83c-1.66,1.52-2.45,2.7-2.52,2.64a3,3,0,0,1,.51-.85,13.81,13.81,0,0,1,1.76-2.05,14.48,14.48,0,0,1,7.86-4.08,11.65,11.65,0,0,1,8.56,2.08,8.49,8.49,0,0,1,1.91,1.92A3.34,3.34,0,0,1,558.35,244.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557,255a5.83,5.83,0,0,1,.17,1.91,29.06,29.06,0,0,1-.35,4.61,28.29,28.29,0,0,1-1.07,4.5,6.35,6.35,0,0,1-.74,1.77c-.15-.06.76-2.82,1.3-6.35S556.87,255,557,255Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.45,302.74s-10.88,17.57-12.37,19.89-3,5.79,0,6.47,3-2.32,4.31-5,5.4-2.15,7.68-4.64a28.56,28.56,0,0,0,3.64-5S563.33,302,563.45,302.74Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M427,211.42l-.56.34A30.27,30.27,0,0,0,425.22,199c-.55-1.7-1.26-3.47-.89-5.21.45-2.1,2.4-3.59,4.44-4.28,3.31-1.12,6.93-.6,10.38-.08l12.82,2a5,5,0,0,1,2.33.76c1.18.9,1.33,2.6,1.36,4.08q.19,9.48-.26,19a9.68,9.68,0,0,1-.82,4.11c-1.2,2.24-3.88,3.18-6.37,3.65a34.12,34.12,0,0,1-12.38.07",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.76,201.92l3.59-2.45,4.75-6.38s1.94-1.07,2.94-.4,1.34,1.46.87,2.33c0,0,2.68.59,2.87,1.42a8.7,8.7,0,0,1-.38,2.86,4.72,4.72,0,0,1,0,2.37,3.59,3.59,0,0,0-.34,1.54s1.73,2,1,4-3.88,6.5-5.55,7.66a37,37,0,0,1-4.85,2.56l-2.07,4L422,214.22Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.05,200a21,21,0,0,1,1.38-2.51,26,26,0,0,1,1.54-2.43,25.35,25.35,0,0,1-1.39,2.51A24.82,24.82,0,0,1,437.05,200Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.18,204s0-.14-.13-.35a1.58,1.58,0,0,0-.56-.66,1.79,1.79,0,0,0-.87-.26,3.05,3.05,0,0,1-.4,0s.13-.1.4-.12a1.58,1.58,0,0,1,1,.23,1.42,1.42,0,0,1,.58.77C438.23,203.84,438.2,204,438.18,204Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.17,205.18s-.15-.08-.36-.23a4.42,4.42,0,0,0-.84-.5,1.72,1.72,0,0,0-1-.15,1,1,0,0,0-.35.17s0-.19.32-.28a1.54,1.54,0,0,1,1.05.11,2.77,2.77,0,0,1,.85.57C442.08,205,442.18,205.16,442.17,205.18Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.63,201.82a6.88,6.88,0,0,1,.78-1.3,7.27,7.27,0,0,1,.94-1.22,6.64,6.64,0,0,1-.79,1.3A6.51,6.51,0,0,1,440.63,201.82Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.74,202.12s0-.14-.09-.34a1.23,1.23,0,0,0-.49-.64,1.42,1.42,0,0,0-.81-.23c-.22,0-.36,0-.37,0s.12-.11.36-.14a1.44,1.44,0,0,1,.93.22,1.19,1.19,0,0,1,.5.74C433.81,202,433.76,202.12,433.74,202.12Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.12,222.24l13.63,10.81,16.73-23.16,10.88,6s-16.3,34.78-20.72,37.85-8.15,2.28-13.83-.16-25.94-21.32-25.94-21.32Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.24,242.66c-.14,0,.24-2.2.07-4.9s-.77-4.83-.63-4.86a12.41,12.41,0,0,1,1.07,4.84A12.27,12.27,0,0,1,408.24,242.66Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.7,211a22.06,22.06,0,0,1-1.12-6.33c0-1.63,2.31-6.72,2.31-6.72l2.87,4Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.35,199.47c.11.13-1.26,1.19-3,2.34s-2.81,2.41-2.92,2.33.14-.43.59-1a10.75,10.75,0,0,1,2-1.8A16.44,16.44,0,0,1,431.35,199.47Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.34,231.14s-6.94,35.77-6.6,39.12,2.18,8.66,6.36,9.57a20.08,20.08,0,0,0,8,0l-5-43.93Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345,201.28l-.48-40.16c-.45-10,5-18.58,15-18.75l.93,0a17.88,17.88,0,0,1,17.12,17.16c.34,8.65.61,18.23.36,22.85-.52,9.58-10.16,10.68-10.16,10.68s-.06,5.83-.06,8.64L360,212.45V213Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.78,193.1a23.21,23.21,0,0,1-12.33-4.21s2.7,7.33,12.3,6.86Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.53,167.83a1.37,1.37,0,0,1-1.38,1.33,1.32,1.32,0,0,1-1.36-1.29,1.37,1.37,0,0,1,1.38-1.33A1.31,1.31,0,0,1,374.53,167.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.37,163.71c-.18.18-1.18-.63-2.66-.69s-2.58.63-2.73.45.11-.4.6-.73a3.69,3.69,0,0,1,2.19-.57,3.63,3.63,0,0,1,2.11.77C375.32,163.31,375.46,163.64,375.37,163.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.38,167.83a1.38,1.38,0,0,1-1.38,1.33,1.3,1.3,0,0,1-1.36-1.29,1.36,1.36,0,0,1,1.37-1.33A1.32,1.32,0,0,1,361.38,167.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.92,163.46c-.18.17-1.19-.64-2.66-.7s-2.58.64-2.73.45.11-.4.59-.72a3.79,3.79,0,0,1,2.2-.58,3.56,3.56,0,0,1,2.11.78C360.86,163.05,361,163.38,360.92,163.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.73,175a9.32,9.32,0,0,1,2.41-.34c.38,0,.74-.08.81-.33a2,2,0,0,0-.2-1.13q-.48-1.38-1-2.91c-1.38-4.14-2.36-7.54-2.19-7.59s1.42,3.25,2.79,7.4l.95,2.92a2.19,2.19,0,0,1,.13,1.49.92.92,0,0,1-.64.52,2.5,2.5,0,0,1-.64.06A10.09,10.09,0,0,1,365.73,175Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.59,158.87c-.22.37-1.63-.09-3.37-.19s-3.2.1-3.36-.3c-.07-.19.24-.51.86-.79a5.84,5.84,0,0,1,5.13.37C361.42,158.33,361.68,158.7,361.59,158.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.62,159.39c-.32.32-1.51-.06-2.95-.11s-2.67.15-2.94-.2c-.12-.18.08-.51.62-.81a5,5,0,0,1,4.75.25C375.6,158.88,375.76,159.23,375.62,159.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345,168.25c-.16-.08-6.5-2.22-6.56,4.34s6.54,5.27,6.55,5.08S345,168.25,345,168.25Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343,175.16s-.12.08-.31.17a1.16,1.16,0,0,1-.85,0,2.81,2.81,0,0,1-1.29-2.55,3.68,3.68,0,0,1,.34-1.63,1.3,1.3,0,0,1,.86-.87.58.58,0,0,1,.68.32c.08.18,0,.31.07.32s.15-.11.1-.38a.79.79,0,0,0-.26-.41.84.84,0,0,0-.63-.17,1.58,1.58,0,0,0-1.2,1,3.89,3.89,0,0,0-.42,1.83,3,3,0,0,0,1.64,2.85,1.22,1.22,0,0,0,1.05-.17C343,175.32,343.06,175.18,343,175.16Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.11,175.91c.22,0,.23,1.49,1.53,2.55s2.89.89,2.91,1.11-.36.29-1,.31a3.75,3.75,0,0,1-2.43-.83,3.26,3.26,0,0,1-1.18-2.15C360.84,176.27,361,175.9,361.11,175.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.83,150.93a1.55,1.55,0,0,0-.72-.91,4.7,4.7,0,0,0-2.45-.43,13.81,13.81,0,0,1-6-1.58,7,7,0,0,0,1.78-1.21,4.13,4.13,0,0,0,1.23-4.09.93.93,0,0,0-.51-.63c-.42-.14-.8.28-1.1.61a3.53,3.53,0,0,1-3.35,1.37,5.82,5.82,0,0,1-2.49-.76l-.08-.1-1-1h0a21.63,21.63,0,0,0-6.72-5.1A22.24,22.24,0,0,0,357.55,136c-3.35.83-6.38,3.51-6.89,6.93-1.85-1.61-4.66-1.63-7-.74l-.05,0c-2.55.88-4,3.54-4.81,6.13l-.12.42a10,10,0,0,1-3.45,3.3c-.25.14-.53.31-.57.6s.2.51.43.68a5.08,5.08,0,0,0,2.05.88,11.16,11.16,0,0,1-.87,1.77c-.29.48-.64,1.06-.39,1.57a1.07,1.07,0,0,0,1.12.5,3.12,3.12,0,0,0,1.18-.52l-.87,2a6,6,0,0,0,2.77-.16c.51,2.43.86,6.92,1.47,8.57,1.74.05,2.17-.13,3,.17,1.13.39.68,2.4,2.16,1.84.76-.28,1.95-3.12,2.21-3.88a37.52,37.52,0,0,0,1.8-15.84,11.94,11.94,0,0,1,3.75-2.65l-.12.1c2.7-.9,5.74-1.78,8.27-.49,2,1,3.1,3.06,4.56,4.71A13.74,13.74,0,0,0,377.34,157c.34,2.9.4,7.64.51,10.34l2.37-5.38v0a9.6,9.6,0,0,0,.5-.95l.06-.1h0c.24-.51.47-1,.77-1.53l0,0a1.69,1.69,0,0,0,2.49-2.23,3.5,3.5,0,0,0-.8-.83,2.67,2.67,0,0,0,2.53.68,2.1,2.1,0,0,0,1.51-2.05,1.78,1.78,0,0,0-1.05-1.44,6.06,6.06,0,0,0,3.44-.72C390.38,152.41,391.05,151.79,390.83,150.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.67,144.07a9.64,9.64,0,0,0-1,.87,6.93,6.93,0,0,0-1.51,3.17,12.23,12.23,0,0,0-.27,2.44c0,.89,0,1.83.1,2.83a27.32,27.32,0,0,1,0,3.15,11.86,11.86,0,0,1-.24,1.66,3.5,3.5,0,0,1-.7,1.61,1.47,1.47,0,0,1-1.36.44,2.17,2.17,0,0,1-1.21-.71,5,5,0,0,1-.9-2.45l.21,0a8.17,8.17,0,0,1-1.2,2,2.8,2.8,0,0,1-1.88,1,1.81,1.81,0,0,1-1-.18,1.66,1.66,0,0,1-.67-.67,1.64,1.64,0,0,1-.19-.86,1.21,1.21,0,0,1,.31-.74l.1.09a6.16,6.16,0,0,1-2.08,1.53,6.51,6.51,0,0,1-.64.24l-.23.05.22-.09c.14-.06.36-.14.62-.27a6.33,6.33,0,0,0,2-1.55l.1.09a1.25,1.25,0,0,0-.08,1.43,1.42,1.42,0,0,0,.6.59,1.61,1.61,0,0,0,.9.16,2.72,2.72,0,0,0,1.75-.95,8.07,8.07,0,0,0,1.14-1.95l.14-.31.06.33a4.86,4.86,0,0,0,.86,2.35,2,2,0,0,0,1.08.63,1.24,1.24,0,0,0,1.16-.38,3.27,3.27,0,0,0,.64-1.5,11.31,11.31,0,0,0,.24-1.62,27.06,27.06,0,0,0,0-3.13c-.05-1-.1-1.95-.08-2.84a12.28,12.28,0,0,1,.3-2.47,6.8,6.8,0,0,1,1.61-3.2A3.87,3.87,0,0,1,353.67,144.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.27,153.75s0,0-.07.07L383,154a2.68,2.68,0,0,1-.41.26,6.07,6.07,0,0,1-.58.3,8.54,8.54,0,0,1-4.12.69,10.9,10.9,0,0,1-5.77-2.2,18.92,18.92,0,0,1-4.92-5.8c-.68-1.17-1.24-2.37-1.85-3.48a12.43,12.43,0,0,0-2.12-2.94,6.56,6.56,0,0,0-2.74-1.72,4.64,4.64,0,0,0-1.46-.18,5.3,5.3,0,0,0-1.34.24,5.74,5.74,0,0,0-2,1.18,5.63,5.63,0,0,0-1.1,1.4,7.35,7.35,0,0,0-.51,1.43.82.82,0,0,1,0-.1c0-.08,0-.18.05-.29a4.87,4.87,0,0,1,.38-1.08,5.43,5.43,0,0,1,1.09-1.45,5.7,5.7,0,0,1,2-1.24,5.12,5.12,0,0,1,1.38-.26,4.46,4.46,0,0,1,1.52.18,6.67,6.67,0,0,1,2.84,1.74,12.79,12.79,0,0,1,2.16,3c.62,1.11,1.18,2.31,1.86,3.47a18.87,18.87,0,0,0,4.84,5.74,10.85,10.85,0,0,0,5.66,2.21,8.62,8.62,0,0,0,4.07-.61A10.55,10.55,0,0,0,383.27,153.75Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.2,149.54a1.54,1.54,0,0,1-.35.24,8.18,8.18,0,0,1-1,.51,10.06,10.06,0,0,1-1.62.51,11.73,11.73,0,0,1-2.07.25,11.19,11.19,0,0,1-2.07-.17,10.09,10.09,0,0,1-1.64-.44,8.32,8.32,0,0,1-1.05-.46,2,2,0,0,1-.36-.22s.55.24,1.46.53a11.72,11.72,0,0,0,1.62.39,11,11,0,0,0,2,.14,11.58,11.58,0,0,0,2-.22,12.14,12.14,0,0,0,1.6-.46C383.66,149.81,384.17,149.51,384.2,149.54Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.55,433.54l-.94,20s21.58,7.59,21.8,11.3l-41.84-.3.09-31.16Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.69,451.73a1.59,1.59,0,0,0-1.2,1.8,1.64,1.64,0,0,0,3.17-.8,1.74,1.74,0,0,0-2.13-1",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M337.57,464.5l.14-3.14,40.06,1.46s1.86.76,1.64,2Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M358.29,453.31c0,.19-1,.27-2,.87s-1.55,1.39-1.74,1.32.13-1.17,1.36-1.88S358.34,453.14,358.29,453.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.67,455c0,.19-.85.5-1.55,1.3S360.21,458,360,458s-.32-1.08.57-2.06S362.66,454.84,362.67,455Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.12,459.91c-.19,0-.47-.91.07-1.94s1.49-1.44,1.58-1.29-.52.71-.94,1.57S365.32,459.89,365.12,459.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358,448.74c-.09.17-1-.1-2.18,0s-2,.39-2.16.23.77-.83,2.13-.89S358.06,448.59,358,448.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.5,448.51a30.37,30.37,0,0,1,.05,4.81l-.16-.24c2.44.86,5.69,2,9.14,3.53a50.18,50.18,0,0,1,9.27,4.95,9.58,9.58,0,0,1,2.3,2.16c.43.62.37,1.1.31,1.08a2.87,2.87,0,0,0-.54-.93,11.25,11.25,0,0,0-2.37-1.95,62.52,62.52,0,0,0-9.26-4.72c-3.43-1.5-6.65-2.71-9-3.66l-.18-.07v-.17A29.31,29.31,0,0,1,358.5,448.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.5,294.35v18.09l7.7,57.77s-2.44,27.09-3.94,42.38c-1.3,13.29.83,36.41.83,36.41h22.83l8.17-77.13,5.07-48.11,9.2-28.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372,430.08l-6,19.19s19.05,12.08,18.32,15.73l-40.59-9.41,8-30.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.89,444.74a1.64,1.64,0,0,0-1.62,1.48,1.58,1.58,0,0,0,1.58,1.5c.84,0,1.78-.81,1.7-1.58a1.67,1.67,0,0,0-1.82-1.39",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M343.73,455.59l.93-3,38.57,10.15s1.61,1.15,1.09,2.28Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M366.71,449.23c-.06.19-1.07,0-2.2.4s-1.87,1-2,.91.42-1.11,1.8-1.53S366.8,449.08,366.71,449.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.53,451.85c0,.19-.95.3-1.83.93s-1.3,1.39-1.5,1.34,0-1.12,1.08-1.88S370.57,451.68,370.53,451.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.67,457.13c-.19,0-.22-1,.56-1.87s1.82-1.07,1.86-.9-.68.58-1.31,1.32S371.87,457.16,371.67,457.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.55,444.72c-.13.15-1-.32-2.11-.51s-2.1-.06-2.16-.24,1-.64,2.29-.4S367.68,444.6,367.55,444.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "390.18 295.58 391.23 305.42 389.96 376.87 371.89 434.26 367.51 448.18 344.19 444.11 362.17 295.61 390.18 295.58",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.47,378.36s0,.12-.08.34l-.3,1-1.17,3.84c-1.05,3.37-2.57,8.26-4.48,14.43-3.87,12.35-9.33,29.81-15.73,50.26l0,.17-.19,0-23.32-4.05-.22,0,0-.2c1.19-5.82,2.44-11.91,3.7-18.11,3.77-18.38,7.33-35.72,10.43-50.86v.06c-3.86-22.47-6.94-40.38-8.71-50.67v0L345.5,318l-1-1.7c-.22-.38-.32-.58-.32-.58s.13.18.36.56l1,1.68c.91,1.49,2.25,3.68,4,6.53h0c1.81,10.28,5,28.19,8.92,50.64v.07c-3.09,15.14-6.62,32.48-10.37,50.86-1.27,6.21-2.52,12.29-3.71,18.12l-.17-.24L367.55,448l-.24.14c6.47-20.44,12-37.88,15.89-50.23l4.59-14.4c.54-1.66.95-2.94,1.24-3.82.14-.43.25-.75.32-1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386,301.44a6.4,6.4,0,0,1-1.27,1.73,17.18,17.18,0,0,1-4.14,3.28,18.08,18.08,0,0,1-5.05,1.91,8,8,0,0,1-2.23.25,26.62,26.62,0,0,0,7.05-2.51A24.12,24.12,0,0,0,386,301.44Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.49,204.56s11.59.15,11.76,13.53-2.95,31.28-2.95,31.28l-29.58-4.83s3.67-24.91,6.81-32.08S333.7,203.34,338.49,204.56Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.2,192.16l.06,4.83s-15.81,9.67-16.7,12.17c-1.39,3.87,1.64,36.59,3,45.86s2.25,24.69,2.25,24.69c-.28,2.35-1.41,12.36-1.61,12.38-2.5,4.77,1,6.94,1,6.94,17,5.13,37.68,1.19,60.1-3.54L391,289.6l-7.33-64s2.13-16.62-6.62-21.43c-1-.53-7-4.81-7-4.81L368.3,197Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.48,199.82a4.5,4.5,0,0,1-1.06.07c-.69,0-1.68,0-2.9,0-2.45-.08-5.83-.33-9.54-.78s-7.05-.95-9.47-1.32l-2.86-.46a3.88,3.88,0,0,1-1-.23,4.18,4.18,0,0,1,1.07,0c.68.06,1.66.16,2.88.3l9.48,1.17c3.7.44,7.06.75,9.5.92l2.88.21A4.06,4.06,0,0,1,370.48,199.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M369.41,222.65a46.66,46.66,0,0,0,5.21,19.73,59,59,0,0,0,13.3,17.09l-2.37-19.13Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M382.69,206.5c-2.78-2.08-7.93-3.21-10.87-1.34a8.37,8.37,0,0,0-3.57,4.07c-2.51,6.8-1,14.11,1,19.54S381,244.65,381,244.65l24-13.49s-16.05-18-17.73-19.88A39.82,39.82,0,0,0,382.69,206.5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.69,206.5a4.63,4.63,0,0,1,.5.38,17,17,0,0,1,1.33,1.24c1.11,1.13,2.57,2.9,4.55,5.06l16,17.87.15.16-.2.11-22.66,12.77-1.31.73-.16.09-.12-.13c-2.68-2.93-5.17-5.89-7.41-8.86a47.15,47.15,0,0,1-3.06-4.51,17.32,17.32,0,0,1-1.18-2.36c-.32-.81-.58-1.61-.83-2.41-2-6.38-2.06-12.64-.23-17.4a7.61,7.61,0,0,1,2.1-3,8.19,8.19,0,0,1,2.89-1.76,8.73,8.73,0,0,1,3-.32,11.21,11.21,0,0,1,2.49.39,12,12,0,0,1,3.17,1.3,5.88,5.88,0,0,1,1,.67s-.33-.24-1-.6a12.38,12.38,0,0,0-3.17-1.22,11.65,11.65,0,0,0-2.45-.35,8.21,8.21,0,0,0-2.89.35,8,8,0,0,0-2.78,1.72,7.3,7.3,0,0,0-2,2.93c-1.76,4.71-1.68,10.89.32,17.21.26.79.52,1.59.83,2.38a17.17,17.17,0,0,0,1.17,2.3,46,46,0,0,0,3,4.48c2.23,3,4.72,5.9,7.39,8.82l-.28,0,1.31-.74L404.84,231l0,.27-15.9-18c-1.95-2.18-3.4-4-4.47-5.12-.53-.58-1-1-1.27-1.28S382.68,206.51,382.69,206.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.61,216.69s0,.13.07.38l.11,1.12c.08,1,.19,2.42.32,4.11.25,3.53.57,8.29.93,13.56s.77,10.08,1.11,13.54c.17,1.69.31,3.07.41,4.1,0,.45.08.82.1,1.12a1.17,1.17,0,0,1,0,.39,1.38,1.38,0,0,1-.09-.38c-.05-.3-.12-.67-.19-1.11-.15-1-.35-2.36-.55-4.09-.42-3.46-.86-8.25-1.24-13.55s-.63-10.09-.8-13.57c-.07-1.69-.13-3.08-.18-4.11,0-.45,0-.82,0-1.12A1.65,1.65,0,0,1,326.61,216.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.64,294.35a1.93,1.93,0,0,1-.44.13l-1.3.29c-.56.13-1.25.26-2.06.4s-1.72.31-2.75.46c-2,.32-4.48.59-7.21.83s-5.73.37-8.88.4-6.17-.08-8.9-.24-5.18-.44-7.22-.74c-1-.13-1.95-.29-2.75-.43s-1.51-.27-2.07-.4l-1.29-.29-.45-.12a1.66,1.66,0,0,1,.47,0l1.31.22c.56.1,1.26.21,2.07.32s1.73.26,2.75.37c2,.27,4.49.47,7.21.65s5.72.24,8.86.22,6.14-.18,8.86-.37,5.16-.46,7.2-.75c1-.12,1.94-.27,2.75-.39s1.5-.23,2.07-.34l1.31-.21A2,2,0,0,1,379.64,294.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.74,280l10.64,5.09,39-14.88,4.72-25.6S396,289.35,396,310.1s3.65,82.1-2,81.56-9.09-.55-9.09-.55.71-75.21.23-82.48c-.48-7.07-3.8-20.7-3.8-20.7l-39,1.59-11.61-1.36Z",
    style: {
      fill: "#3270F9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.63,286.46a5.84,5.84,0,0,1-.27-.74,14.69,14.69,0,0,1-.52-2.18,18.25,18.25,0,0,1,.54-8.22,17.78,17.78,0,0,1,2.48-5.16,6.21,6.21,0,0,1,2.35-2.25,2.28,2.28,0,0,1,1.78-.16,2.11,2.11,0,0,1,1.25,1.36,6.38,6.38,0,0,1-.26,3.62,22.35,22.35,0,0,1-1.34,3.47,39.83,39.83,0,0,1-4.17,6.57c-.75,1-1.52,2-2.23,2.86l-.15.19-.2-.13a33.72,33.72,0,0,1-9.48-9.91,6,6,0,0,1-.7-1.44,2,2,0,0,1,.1-1.64,1.67,1.67,0,0,1,1.41-.76,2.54,2.54,0,0,1,1.45.44,10.74,10.74,0,0,1,2,1.88,16.35,16.35,0,0,1,1.49,2,18,18,0,0,1,2.65,6.9,16.16,16.16,0,0,1,.19,2,2.89,2.89,0,0,1,0,.7,5.58,5.58,0,0,1-.08-.69c0-.45-.12-1.12-.27-2a18.59,18.59,0,0,0-2.76-6.74,18.19,18.19,0,0,0-1.49-1.93,11.1,11.1,0,0,0-1.9-1.78,2,2,0,0,0-1.21-.36,1.22,1.22,0,0,0-1.05.56,1.61,1.61,0,0,0-.05,1.28,5.3,5.3,0,0,0,.67,1.32,33.52,33.52,0,0,0,9.37,9.73l-.35.05c.72-.9,1.48-1.86,2.22-2.85a40.57,40.57,0,0,0,4.13-6.48,21.77,21.77,0,0,0,1.32-3.39,6,6,0,0,0,.29-3.33,1.63,1.63,0,0,0-1-1.07,1.84,1.84,0,0,0-1.43.13,5.76,5.76,0,0,0-2.18,2.09,17.79,17.79,0,0,0-2.49,5,18.5,18.5,0,0,0-.69,8.08,16.81,16.81,0,0,0,.42,2.19A3.74,3.74,0,0,1,344.63,286.46Z",
    style: {
      fill: "#3270F9"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57,169.17a8.75,8.75,0,0,1,4-3.74,6.08,6.08,0,0,1,5.8,1,7.35,7.35,0,0,1,2.67,5.34l-2,12.05a2.44,2.44,0,0,1-2.09,1.57,1.8,1.8,0,0,1-1.61-.71A1.19,1.19,0,0,1,64.1,183a3.73,3.73,0,0,1-1.71.82,1.26,1.26,0,0,1-1.41-1,1.71,1.71,0,0,1,.49-1.11,11.23,11.23,0,0,1,3.47-2.85,9.91,9.91,0,0,1-6-.54,5.8,5.8,0,0,1-3.44-4.73A7.74,7.74,0,0,1,57,169.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.91,163.13a24.54,24.54,0,0,1,19.92-7.39c4.3.39,6,1.47,9,2.64a13.59,13.59,0,0,1,7.18,5.94,22.82,22.82,0,0,1,3.34,10.85,45.2,45.2,0,0,1-1.1,9.82c-.71,3.87-3.35,10.5-5.64,10.5l-8.88,2.7c-5.5-.4-11.07-.81-16.27-2.63S71.36,190.31,69,185.33C65.73,178.41,68.45,168.51,73.91,163.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.74,164l13.79-3.84,3.41.77c7.77.86,12.21,10,11.59,16.31-.69,7-1.81,15.52-3.47,20.55-3.34,10.13-12.28,10-12.28,10l-.56,7,6.8,3.86-7.69,24.88-16.45,0L68,211l6.71-.7.62-4.73,3.55-38.35A3.71,3.71,0,0,1,82.74,164Z",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.77,193.71a2.27,2.27,0,0,1,3.66-1.14,3,3,0,0,1,.84,3h0a2.73,2.73,0,0,1-2.08.93,2.22,2.22,0,0,1-.37,0,2.48,2.48,0,0,1-1.6-.83A2.22,2.22,0,0,1,92.77,193.71Z",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107,185.64a1.35,1.35,0,0,1-1.51,1.14,1.3,1.3,0,0,1-1.18-1.43,1.36,1.36,0,0,1,1.51-1.13A1.29,1.29,0,0,1,107,185.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.79,180.49c-.19.15-1.08-.77-2.52-1s-2.6.32-2.73.12.16-.38.67-.64a3.77,3.77,0,0,1,2.22-.3,3.56,3.56,0,0,1,2,1C108.78,180.09,108.88,180.42,108.79,180.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.3,190.82a9.31,9.31,0,0,1,2.4,0c.37,0,.73,0,.84-.24a1.86,1.86,0,0,0-.07-1.12l-.63-3c-.86-4.22-1.42-7.66-1.25-7.69s1,3.35,1.87,7.57c.2,1,.39,2,.58,3a2.14,2.14,0,0,1-.05,1.47.92.92,0,0,1-.69.43,2.17,2.17,0,0,1-.63,0A9.92,9.92,0,0,1,98.3,190.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.79,207.84a26.86,26.86,0,0,1-13.32-6s2.54,7.81,13.11,8.53Z",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.92,191.12c.23,0,0,1.58,1.14,2.91s2.84,1.42,2.81,1.64-.42.24-1.12.15a3.93,3.93,0,0,1-2.36-1.29,3.4,3.4,0,0,1-.86-2.42C93.58,191.45,93.81,191.1,93.92,191.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.84,175.38c-.3.31-1.36-.1-2.66-.2s-2.42.06-2.65-.3c-.1-.18.09-.49.59-.77a3.88,3.88,0,0,1,2.2-.4,3.8,3.8,0,0,1,2.08.8C108.84,174.88,109,175.23,108.84,175.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.36,183.25a1.35,1.35,0,0,0,1.12,1.51,1.29,1.29,0,0,0,1.54-1,1.36,1.36,0,0,0-1.13-1.52A1.3,1.3,0,0,0,91.36,183.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.32,177.84c.14.2,1.25-.43,2.69-.24s2.41,1,2.59.88,0-.41-.46-.8a3.77,3.77,0,0,0-2-.92,3.57,3.57,0,0,0-2.17.41C89.43,177.46,89.24,177.75,89.32,177.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.68,173.31c.24.36,1.4.16,2.74.31s2.44.53,2.74.22c.14-.15,0-.5-.45-.87a4.18,4.18,0,0,0-2.16-.82,4.11,4.11,0,0,0-2.27.39C90.77,172.82,90.57,173.14,90.68,173.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.78,185c.13-.78-.47-2.75-1.22-3-2-.65-5.69-1.09-6.57,4.09-1.2,7.08,6.16,6.83,6.2,6.63S78.35,187.63,78.78,185Z",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.68,189.77s-.14.06-.37.12a1.22,1.22,0,0,1-.92-.13,3.12,3.12,0,0,1-1-3,4,4,0,0,1,.65-1.71,1.44,1.44,0,0,1,1.08-.79.64.64,0,0,1,.67.46c.07.22,0,.35,0,.37s.17-.09.17-.4a.82.82,0,0,0-.21-.49.92.92,0,0,0-.65-.29,1.73,1.73,0,0,0-1.47.88,4.27,4.27,0,0,0-.77,1.9c-.19,1.43.31,2.89,1.29,3.36a1.36,1.36,0,0,0,1.16,0C75.64,189.94,75.7,189.78,75.68,189.77Z",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.27,182,78.88,184c8.62-6.65,25.91-23.76,24.94-22.74a23,23,0,0,0-11-2.4c-5.92.37-17.26,2.1-17.82,9S77.27,182,77.27,182Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.81,168.83a45.68,45.68,0,0,0-1.59,7.73,45.71,45.71,0,0,0,.29,7.89,7.74,7.74,0,0,1-.59-2.27A23.36,23.36,0,0,1,68.85,171,7.31,7.31,0,0,1,69.81,168.83Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.45,176.48A30.5,30.5,0,0,0,74,175.9,31.08,31.08,0,0,0,79.65,174a69.5,69.5,0,0,0,6.58-3.35c4.57-2.59,8.61-5.11,11.5-7l3.41-2.23a8.93,8.93,0,0,1,1.28-.77,8.26,8.26,0,0,1-1.16.94c-.77.58-1.91,1.39-3.33,2.37-2.84,1.95-6.86,4.53-11.44,7.12a62.65,62.65,0,0,1-6.65,3.34,29.09,29.09,0,0,1-5.81,1.8,18.81,18.81,0,0,1-4.09.36,9.22,9.22,0,0,1-1.11-.07C68.58,176.52,68.45,176.5,68.45,176.48Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70,172a7.34,7.34,0,0,1,1.3-.35c.84-.18,2-.47,3.53-.86a79.33,79.33,0,0,0,21.93-9.42c1.31-.81,2.35-1.49,3.06-2a7.89,7.89,0,0,1,1.15-.7,6.73,6.73,0,0,1-1,.87c-.68.53-1.69,1.25-3,2.11a68.59,68.59,0,0,1-10.6,5.71,69.8,69.8,0,0,1-11.44,3.76c-1.51.34-2.73.58-3.59.7A6.18,6.18,0,0,1,70,172Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.16,442.28,45,461.35l3.37,15.36a2,2,0,0,1-1.6,2.36h0a1.87,1.87,0,0,1-1.67-.57c-2.76-2.91-12.87-13.67-12.71-15.06.19-1.61-.09-20.21-.09-20.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.76,479.07,32.43,462.15l0,.81a3,3,0,0,0,.61,1.93c1.14,1.48,4.37,5.48,12,13.61a1.91,1.91,0,0,0,1.73.57Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.53,456.14a1.21,1.21,0,0,1,.26,1.56,1.11,1.11,0,0,1-1.52.28,1.26,1.26,0,0,1-.27-1.66,1.15,1.15,0,0,1,1.61-.1",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M42.78,470.55c.11.06.57-.92,1.71-1.41a5.89,5.89,0,0,1,2.18-.34s-.21-.2-.65-.28a2.92,2.92,0,0,0-1.7.23A3,3,0,0,0,43,469.87C42.78,470.26,42.74,470.54,42.78,470.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44,473.17a14.29,14.29,0,0,1,1.69-.76,14.34,14.34,0,0,1,1.85-.16,2.09,2.09,0,0,0-2-.24C44.5,472.29,43.93,473.11,44,473.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.42,467.18A18.13,18.13,0,0,1,43,465.83a17.24,17.24,0,0,1,2.82-.54,4.2,4.2,0,0,0-3,.15A4.21,4.21,0,0,0,40.42,467.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.29,461.35c.05.11,1.11-.29,2.46-.28s2.41.38,2.46.26a3.75,3.75,0,0,0-2.46-.68A3.73,3.73,0,0,0,40.29,461.35Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5,455.74a9.23,9.23,0,0,1,2.55-.36,9,9,0,0,1,2.47.74s-.17-.29-.59-.56a4.1,4.1,0,0,0-3.77-.28C40.7,455.48,40.47,455.7,40.5,455.74Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.05,454.31s.08-.25.06-.72a5.23,5.23,0,0,0-.49-1.91,2.21,2.21,0,0,0-.9-1.1.75.75,0,0,0-.88.14,1.23,1.23,0,0,0-.33.85,2.75,2.75,0,0,0,2.28,2.65A3.12,3.12,0,0,0,46,452.67a1.13,1.13,0,0,0,.09-.92.76.76,0,0,0-.78-.44,2.61,2.61,0,0,0-1.26.6,5.47,5.47,0,0,0-1.34,1.43,1.84,1.84,0,0,0-.32.65,8.87,8.87,0,0,1,1.83-1.84,2.6,2.6,0,0,1,1.11-.5.42.42,0,0,1,.43.24.82.82,0,0,1-.1.61,2.81,2.81,0,0,1-2.76,1.31,2.38,2.38,0,0,1-2-2.23.89.89,0,0,1,.2-.6.42.42,0,0,1,.49-.08,2,2,0,0,1,.78.91A7.52,7.52,0,0,1,43.05,454.31Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.24,298S33.32,319.44,33.82,338s3.81,37.69,3.1,47.92c-.49,6.94-6.29,23.88-7.29,39.4s0,34.24,0,34.24H46.26s3.56-24.82,6.91-39.14c2.72-11.63,3-15.58,6.19-25s8.68-39.41,10.81-51,4.14-27.44,4.14-27.44l2.4-15.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.44,347.64c-.31,1.38,2.88,47.09,4.84,56.68s4.08,52,4.08,52l17.59-.95s2.11-29.3,2.67-38.94-1.26-20.49-1.48-29.44,1.81-26.53,3.66-43.66,3.57-40.67-2.89-40.91c-1.68-.06-28.2-1.26-28.2-1.26L72.37,331,68,340.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.44,248.47s-1.68,7.08-2.87,13.44c-1.38,7.35.81,17.13,7.39,17.51s10-9.61,10-9.61l2.57-17.28-9.69-2.23Z",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.2,275.34c-.54.06,1.33,18,1.33,18l-1.22,15.37,10.49,3.46a81.37,81.37,0,0,0,3.83-18.62,137.93,137.93,0,0,0-.52-20.91Z",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.76,270.93a1.47,1.47,0,0,1-.06-.47c0-.36-.05-.8-.08-1.33,0-1.25-.11-2.91-.19-4.93l-.24-7.3c0-1.38-.1-2.82-.16-4.31l0-.55v0a.14.14,0,0,0,.07.12l0,0-.14,0-.27-.08-1.11-.3-2.27-.63L40,249.9l.28-.12a71.07,71.07,0,0,0-5.58,11.87c-.55,1.54-.9,2.81-1.14,3.69a7.41,7.41,0,0,1-.38,1.35,9,9,0,0,1,.21-1.39,34.32,34.32,0,0,1,1-3.76,63.15,63.15,0,0,1,5.46-12l.09-.17.19.05,4.38,1.21,2.27.63,1.1.31.28.08.14,0s0,0,.15.09a.45.45,0,0,1,.09.2v0c0,.2,0,.38,0,.57.05,1.5.09,2.94.13,4.32,0,2.73.09,5.21.13,7.31s0,3.68,0,4.93c0,.53,0,1,0,1.34A1.57,1.57,0,0,1,48.76,270.93Z",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72,209.91s-19.32,2.68-20.6,5.4,2.55,56.87,2.07,59S42,295.58,44.24,298s60.67,4.43,60.67,4.43,2.13-34,2.11-34.77,2.76-19.18,2.76-19.18l3-25.15L98,215.74l-2.51-4.84s-9.66,12-9.13,11.56L75.25,206.18s0,0,0,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.71,214.26a16.68,16.68,0,0,0-7.6,6.51C42.81,224.6,33.43,248,33.43,248s22.06,5.63,21.18,4.79S52.71,214.26,52.71,214.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.75,223.28A19.78,19.78,0,0,1,121,234.76c1.54,5.7,7.67,36.82,7.67,36.82s-20.35,4.77-20.17,3.7-.88-15.13-.88-15.13l2-24.24Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.47,235.91a5.52,5.52,0,0,1,.36,1.11,13.15,13.15,0,0,1,.31,1.32c.11.52.24,1.11.33,1.78a39.46,39.46,0,0,1,.16,10.42,44.67,44.67,0,0,1-2.37,10.15c-.46,1.26-.87,2.26-1.19,2.93a5.47,5.47,0,0,1-.54,1c-.08,0,.56-1.55,1.38-4.07a52.09,52.09,0,0,0,2.2-10.1,44.47,44.47,0,0,0,0-10.31C110.78,237.53,110.38,235.93,110.47,235.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98,215.74a5.41,5.41,0,0,1-.5,1L96,219.3l-5.5,9.08-.19.31-.21-.3-3.93-5.79.39.05-2.71,2.51c-1.37,1.24-2.7,2.46-4.05,3.56l-.27.22-.12-.33c-2-5.37-3.86-10-5.22-13.31l-1.6-3.88a9.11,9.11,0,0,1-.53-1.43,10,10,0,0,1,.69,1.36c.43.88,1,2.18,1.74,3.82,1.44,3.27,3.37,7.9,5.39,13.26l-.39-.11c1.31-1.08,2.64-2.31,4-3.55l2.71-2.5.22-.2.17.25,3.9,5.81h-.4l5.65-9,1.64-2.53A7.05,7.05,0,0,1,98,215.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.23,284.32s7.62-3.92,10.39-6.05S64,240.85,64,240.85l41.5,2.68-3.66,40.21,4,4.08,3,21.84s2,89.2-3.22,89c-15.9-.61-64.94-2-64.06-7.79s6.2-89,6.2-89l-5-3.85Z",
    style: {
      fill: "#3270F9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "65.41 242.13 59.35 212.2 65.32 210.76 71.27 242.79 65.41 242.13",
    style: {
      fill: "#3270F9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "98.04 244.18 106.44 220.06 111.18 222.5 103.46 245.39 98.04 244.18",
    style: {
      fill: "#3270F9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.41,260.33l-16-.84A2.57,2.57,0,0,1,74,256.8h0a2.57,2.57,0,0,1,2.69-2.42l16,.85a2.56,2.56,0,0,1,2.42,2.69h0A2.55,2.55,0,0,1,92.41,260.33Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.85,283.74a9.78,9.78,0,0,1-1.67.43c-1.08.24-2.66.55-4.61.91-3.9.7-9.34,1.51-15.38,2s-11.53.5-15.5.42c-2-.05-3.58-.11-4.69-.18a10.5,10.5,0,0,1-1.72-.16,10.68,10.68,0,0,1,1.73-.05l4.69,0c4,0,9.43-.11,15.45-.57s11.45-1.21,15.36-1.82l4.63-.75A12,12,0,0,1,101.85,283.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.53,441l.15,15s15.81,5.79,16,8.74L87.25,465l-.11-7.11-1.78-14.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.25,465l0-2.38,29.27.54s1.36.59,1.21,1.56Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.78,456.1c0,.15-.74.22-1.47.72s-1.11,1.13-1.25,1.07.08-.94,1-1.51S101.81,456,101.78,456.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.27,457.44c0,.15-.6.41-1.1,1.05s-.64,1.32-.79,1.32-.25-.86.39-1.65S105.27,457.3,105.27,457.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.32,461.37c-.13,0-.35-.72,0-1.55s1.06-1.17,1.13-1-.37.57-.66,1.25S107.47,461.35,107.32,461.37Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.36,249.67s1-10.06,1.71-12.79,1.51-4.29,2.52-4.51,4.33.67,5.78.54,5.46-1.69,7-1c.54.25.91,1.48-.41,3.06a5.37,5.37,0,0,1-2.6,1.87s6.25,5.07,5.43,7.41-2.61.67-3.1.49-4.42-3.19-4.42-3.19,2.69,7.68,1.56,8.87-3.72-1.55-3.72-1.55l-.2,11.7c-.8.67-11.39,0-12.87-2.42C35.69,257.65,39.36,249.67,39.36,249.67Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.36,249.67a2.43,2.43,0,0,1-.14.38l-.47,1.11c-.4,1-1,2.38-1.74,4.21-.18.45-.36.94-.54,1.45-.09.26-.18.52-.25.79a1.89,1.89,0,0,0-.08.4v.08s0,0,0,0l.14.15a7.22,7.22,0,0,0,3.39,1.52,31.9,31.9,0,0,0,4.33.69c.77.06,1.57.12,2.38.14.41,0,.82,0,1.23,0,.2,0,.41,0,.61-.05l.29-.05c.1,0,.14-.05.22-.07l-.08.16c0-3.55.11-7.5.17-11.71v-.57l.41.41a6.52,6.52,0,0,0,2.51,1.73c.46.12.92,0,1-.51a4.66,4.66,0,0,0,0-1.58,38.3,38.3,0,0,0-1.75-6.7l-.27-.8.67.51c1.12.85,2.32,1.75,3.55,2.62a8.87,8.87,0,0,0,.75.5c.31.14.57.33.83.46.51.29,1.09.43,1.45.1a1.8,1.8,0,0,0,.57-1.42,3.87,3.87,0,0,0-.63-1.56,24.38,24.38,0,0,0-4.75-5l-.34-.3.45-.14a5.78,5.78,0,0,0,2.9-2.4,2.18,2.18,0,0,0,.35-1.68.79.79,0,0,0-.18-.31.74.74,0,0,0-.32-.16,3.21,3.21,0,0,0-.88-.08,17.56,17.56,0,0,0-3.6.66c-.59.15-1.16.3-1.76.41a5.72,5.72,0,0,1-1.8,0c-1.15-.14-2.24-.36-3.3-.48a2.29,2.29,0,0,0-1.42.13,2.94,2.94,0,0,0-.91,1.09A17.71,17.71,0,0,0,40.82,239c-.52,3.32-.84,6-1.07,7.81-.12.89-.21,1.58-.27,2.1s-.11.72-.12.72a3.36,3.36,0,0,1,0-.73c0-.52.11-1.22.19-2.11.18-1.83.45-4.5.93-7.84A17.5,17.5,0,0,1,42,233.62a3.22,3.22,0,0,1,1-1.24,1.57,1.57,0,0,1,.84-.24,5.77,5.77,0,0,1,.83,0c1.08.11,2.17.33,3.3.46a5.49,5.49,0,0,0,1.67,0c.57-.11,1.14-.26,1.73-.42a18.66,18.66,0,0,1,3.7-.69,3.27,3.27,0,0,1,1,.1,1.09,1.09,0,0,1,.52.27,1.19,1.19,0,0,1,.31.51,2.63,2.63,0,0,1-.39,2.07,6.13,6.13,0,0,1-3.21,2.63l.1-.43a24.55,24.55,0,0,1,4.86,5.13,4.2,4.2,0,0,1,.71,1.78,1.36,1.36,0,0,1,0,.53,1.48,1.48,0,0,1-.15.49,2.18,2.18,0,0,1-.59.85,1.36,1.36,0,0,1-1.06.3,2.61,2.61,0,0,1-1-.34c-.29-.15-.54-.34-.8-.45s-.56-.36-.83-.54c-1.25-.88-2.44-1.79-3.57-2.64l.41-.29a40.07,40.07,0,0,1,1.77,6.8,5.54,5.54,0,0,1,0,1.77,1.16,1.16,0,0,1-.21.47,1.27,1.27,0,0,1-.41.33,1.49,1.49,0,0,1-1,.08,6.88,6.88,0,0,1-2.76-1.89l.43-.16c-.09,4.21-.16,8.16-.23,11.71v.12l-.07,0a2.14,2.14,0,0,1-.39.16l-.33.05c-.22,0-.44,0-.65,0-.43,0-.85,0-1.26,0-.83,0-1.63-.09-2.41-.17a29.68,29.68,0,0,1-4.37-.74,7.29,7.29,0,0,1-3.54-1.66l-.16-.18a.4.4,0,0,1-.07-.16.66.66,0,0,1,0-.14,3,3,0,0,1,.09-.45c.08-.28.18-.54.27-.8.19-.52.39-1,.57-1.46.76-1.82,1.41-3.22,1.86-4.17.21-.44.38-.8.52-1.07A1.4,1.4,0,0,1,39.36,249.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.68,233.91a7.4,7.4,0,0,1,4.22.65A7.35,7.35,0,0,1,53.37,237a40.6,40.6,0,0,0-3.67-2C47.57,234.16,45.67,234.07,45.68,233.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.55,238.62c0-.07.36-.2,1-.21a5.24,5.24,0,0,1,2.39.6,5.31,5.31,0,0,1,1.87,1.63c.36.52.46.91.4.93a11.55,11.55,0,0,0-2.51-2.09A11.42,11.42,0,0,0,45.55,238.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.57,456.8l-41.89-72.63L66.78,266.42,51,239.11c-1.2-2.09-4.44-.2-3.23,1.89l42.93,74.46,67.91,117.75,13.59,23.58-22.82-.05v6.05l52.12.13v-6.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.57,456.8l1.64,0h23.42V463h-.11L149.4,463h-.18v-.18c0-1.83,0-3.93,0-6.05v-.18h.18l22.82,0-.17.3L73.55,286.18,57.76,258.8Q53.86,252,50,245.39c-.64-1.11-1.28-2.21-1.91-3.32l-.48-.82a2.71,2.71,0,0,1-.36-1,2.08,2.08,0,0,1,.92-1.86,2.19,2.19,0,0,1,2-.31,3,3,0,0,1,1.36,1.5l1.89,3.28c10,17.43,19.74,34.25,29,50.28l49,85.14c13.93,24.24,25.2,43.84,33,57.4l9,15.64,2.33,4.08c.52.92.78,1.4.78,1.4s-.28-.45-.81-1.35-1.32-2.27-2.36-4c-2.06-3.57-5.11-8.81-9-15.57l-33.19-57.37-49.13-85.1c-9.24-16-18.95-32.83-29-50.26l-1.89-3.27c-.33-.57-.59-1.09-1.11-1.28a1.65,1.65,0,0,0-1.55.25,1.59,1.59,0,0,0-.71,1.39,5.27,5.27,0,0,0,.77,1.62l1.91,3.31,7.74,13.41L74,285.92l98.41,170.77.17.31h-.35l-22.82-.07.19-.18c0,2.12,0,4.22,0,6.05l-.18-.17,52.12.18-.12.12c0-2.14,0-4.18,0-6.06l.1.11-18.57-.1-4.78,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.31,462.63H150c-.66.78-.12,4.35.81,4.78a4.34,4.34,0,0,0,3-.05,7.46,7.46,0,0,1,3-.5c1.27.17,2.41,1.11,3.68,1s2.21-1.26,3.44-1.25c1.41,0,2.53,1.54,3.93,1.39.91-.1,1.62-.89,2.52-1,1.4-.23,2.63,1.09,4,1.11s2.72-1.4,4.2-1.27c1.3.11,2.25,1.38,3.53,1.58,1.86.3,3.45-1.71,5.34-1.58,1.2.08,2.23,1,3.44,1s2.26-.95,3.47-1.11a6,6,0,0,1,3.11.81,4.25,4.25,0,0,0,3.15.46C201.63,467.56,202.14,463.33,201.31,462.63Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.28,307.58c-.34.73-2.41,9.28-2.41,9.28a15.84,15.84,0,0,0-4.85,2.27,21,21,0,0,0-3.78,4.63l2.41,3.83s-.86,3.32-1.27,6.2,1.08,3.58,1.08,3.58-1.15,4.74,1.35,5.13c.8.13,2.4-2.25,2.4-2.25a2.25,2.25,0,0,0,1.78,2.4c1.68.46,3.09-1.29,3.09-1.29s1.57,2.89,3.58,1.83,3.33-5.31,3.33-5.31,2.89-4.45,2.31-8.26-.76-6.68-.76-6.68,1.5-4.58,2.85-8.46c.85-2.44,1.51-5.29-2.72-7.1A11,11,0,0,0,110.28,307.58Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.19,328.63a29.27,29.27,0,0,1-2.41,5c-1,1.81-1.9,3.37-2.41,4.15h0s0,.06,0,.05,0,0,0-.06-.08-.11-.08-.13.11-.08.2.08a.21.21,0,0,1-.12.31.27.27,0,0,1-.32-.34v0c.38-.86,1.19-2.47,2.18-4.28A30.87,30.87,0,0,1,106.19,328.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.08,331.42a36,36,0,0,1-3.26,5.07,35.11,35.11,0,0,1-3.68,4.77,33.74,33.74,0,0,1,3.26-5.07A34.35,34.35,0,0,1,111.08,331.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115,333.22a14.91,14.91,0,0,1-2.14,4.26,24.35,24.35,0,0,1-2.75,3.88,19.34,19.34,0,0,1,2.31-4.16A42.48,42.48,0,0,1,115,333.22Z",
    style: {
      fill: "#263238"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCleaning);
export default __webpack_public_path__ + "static/media/Cleaning .e30333fd8fe7207139c4a77c748dcbf5.svg";
export { ForwardRef as ReactComponent };